// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-19T18:44:48.449Z
// Property: Azure Carnes Crossing (ID: 6767906449167486)
// Collections: 34 amenities, 8 floorplans (live), 22 photos, 81 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "6767906449167486",
  "property_external_id": "33553",
  "property_zillow_url": "https://www.zillow.com/apartments/summerville-sc/azure-carnes-crossroads/BrVQL2/",
  "property_apartments_url": "https://www.apartments.com/azure-carnes-crossroads-summerville-sc/zwyfmtw/",
  "property_google_business_url": "https://www.google.com/maps/place/Azure+Carnes+Crossroads/data=!4m2!3m1!1s0x0:0x961c3f8b608f0fe?sa=X&ved=2ahUKEwik8cSL6rWVAxUIkmoFHaqjCDsQ_BJ6BAgcEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54711812167",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": "5669915 ",
  "property_status": null,
  "property_slug": "azure-carnes-crossing",
  "property_name": "Azure Carnes Crossing",
  "property_website_url": "https://www.lifeatazure.com/",
  "property_domain": "https://www.lifeatazure.com/",
  "property_address": "900 Conway Cir",
  "property_full_address": "900 Conway Cir, Summerville, SC 29486",
  "property_address_1": "900 Conway Cir",
  "property_address_2": null,
  "property_address_city": "Summerville",
  "property_address_state": "SC",
  "property_address_zip_full": "29486-8106",
  "property_address_zip": "29486",
  "property_address_country": "US",
  "property_address_county": "Berkeley County",
  "property_neighborhood_address": "Goose Creek",
  "property_address_latitude": "33.0592594",
  "property_address_longitude": "-80.091554",
  "property_email": "azure@alapts.com",
  "property_phone": "(843) 821-7970",
  "property_call_tracking_phone": "854-264-6772",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Summerville apartment living, polished down to the details.</strong> Azure Carnes Crossroads pairs gourmet kitchens, spa-inspired baths, and spacious closets with inviting social spaces and a resort-inspired pool—explore the <a href=\"/amenities\">signature features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_long_description": "Discover elevated living at Azure Carnes Crossroads, where upscale apartment homes meet the charm of Summerville, SC. Enjoy spacious layouts with modern finishes, gourmet kitchens, custom cabinetry, designer details, spa-inspired bathrooms, expansive walk-in closets, and screened-in patios perfect for relaxing outdoors. From the resort-style pool and 24-hour fitness center to the game lounge, pet-friendly dog park, and inviting social spaces, Azure Carnes Crossroads offers everything you need to relax, connect, and enjoy the South Carolina lifestyle you’ve been searching for.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-acea-7354-bc02-6f9b29afdd2a.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and lounge area with apartment buildings in the background.",
    "public_id": "019e17c1-acea-7354-bc02-6f9b29afdd2a",
    "storage_key": "property/6767906449167486/019e17c1-acea-7354-bc02-6f9b29afdd2a.webp",
    "width": 1024,
    "height": 683
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "295",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.96610169491525",
  "property_admin_fee": "250",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Administrative Fee: $250\nApplication Approval Fee: Starting at $599\nOne-Time Pet Fee: $400 per pet (non-refundable)\nMonthly Pet Rent: $25 per pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://9316656.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://azurecarnescrossroads.loftliving.com/login",
  "property_apply_now_url": "https://9316656.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-9fb8-7368-a741-dd4149dd2859.webp",
  "property_primary_logo_media": {
    "alt_text": "Azure Carnes Crossroads logo.",
    "public_id": "019e21fe-9fb8-7368-a741-dd4149dd2859",
    "storage_key": "property/6767906449167486/019e21fe-9fb8-7368-a741-dd4149dd2859.webp",
    "width": 3072,
    "height": 937
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-8b7c-721b-943d-84c827c22f7b.webp",
  "property_icon_media": {
    "alt_text": "The property's logo.",
    "public_id": "019e21fe-8b7c-721b-943d-84c827c22f7b",
    "storage_key": "property/6767906449167486/019e21fe-8b7c-721b-943d-84c827c22f7b.webp",
    "width": 2697,
    "height": 2697
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-8b7c-721b-943d-84c827c22f7b.webp",
  "property_fav_icon_media": {
    "alt_text": "The property's logo.",
    "public_id": "019e21fe-8b7c-721b-943d-84c827c22f7b",
    "storage_key": "property/6767906449167486/019e21fe-8b7c-721b-943d-84c827c22f7b.webp",
    "width": 2697,
    "height": 2697
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-a03b-7376-bbd1-389120f1ecdf.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Azure Carnes Crossroads logo",
    "public_id": "019e21fe-a03b-7376-bbd1-389120f1ecdf",
    "storage_key": "property/6767906449167486/019e21fe-a03b-7376-bbd1-389120f1ecdf.webp",
    "width": 3072,
    "height": 937
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e21fe-9f63-7209-a94d-20b0f4a7a7d1.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Azure Carnes Crossroads logo",
    "public_id": "019e21fe-9f63-7209-a94d-20b0f4a7a7d1",
    "storage_key": "property/6767906449167486/019e21fe-9f63-7209-a94d-20b0f4a7a7d1.webp",
    "width": 3072,
    "height": 937
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#006a71",
  "property_secondary_color": "#bab8af",
  "property_font_color": null,
  "property_color_4": "#000000",
  "property_color_3": "#5a7d95",
  "property_color_5": "#ffffff",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "684 - 1559",
  "property_sqft_min": "684",
  "property_sqft_max": "1559",
  "property_price_range": "1370 - 2285",
  "property_price_min": "1370",
  "property_price_max": "2285",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/carnescrossroadhvac/",
  "property_instagram_url": "https://www.instagram.com/uptown_carnes_crossroads/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ83CX8gph_ogR_vAItvjDYQk",
  "property_youtube_url": "https://www.youtube.com/watch?v=EFWWhaTuGV4&vl=en-US&t=1420",
  "property_yelp_url": "https://www.yelp.com/biz/azure-myrtle-beach",
  "property_tiktok_url": "https://www.tiktok.com/@azurecarnescr",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Azure Carnes Crossroads",
  "property_home_romance_title": "Embrace a Life of Love at Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease meets resort-style downtime.</strong> Start with a 24/7 fitness session or yoga-room stretch, then unwind at the lagoon-style saltwater pool, sundeck, screened cabana, pavilion lounge, or hammock greenspace with a firepit. Smart conveniences like a car care center, drive-thru mail, available garages and storage, and select elevator access keep routines simple, while apartment finishes such as granite countertops, stainless steel appliances, custom cabinetry, and screened outdoor space add polish at home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Summerville with open living areas, thoughtful bedroom separation, generous closets, and select options like screened-in patios or balconies, retreat views, and corridor-attached garages. Inside, granite countertops, stainless steel appliances, designer tile backsplashes, custom cabinetry, lofty ceilings, modern lighting, and in-home washer/dryer convenience bring a polished finish to every layout.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Azure Carnes Crossroads.</strong> Preview granite kitchen counters, custom cabinetry, modern lighting, open living spaces, and screened outdoor areas made for Lowcountry air. Then browse the full gallery for lagoon-style pool views, a shaded cabana, landscaped courtyard seating, and a bright social lounge with blue sofas, a pool table, and statement pendants.</p>",
  "property_home_neighborhood_blurb": "<p><strong>At the center of Carnes Crossroads.</strong> Azure Carnes Crossroads places daily stops close by, from The Marketplace and Steel City Pizza to Neighborhood Tap House, coffee, and bagels. Beyond the essentials, the area adds Lowcountry appeal with ponds, trails, green space, and the Green Barn’s event setting—all near Highway 17A, Highway 176, and I-26 for easy Charleston-area connections.</p>",
  "property_home_reviews_blurb": "<p><strong>Responsive service, well-kept spaces, and everyday ease.</strong> Reviews for Azure Carnes Crossroads often call out the helpful team, prompt maintenance, spacious apartments, and thoughtful extras—from package service and storage options to food trucks, pet-friendly living, and poolside downtime. Add in quick access to Summerville and Goose Creek shopping, and it’s easy to see why residents have so much to say.</p>",
  "property_neighborhood_blurb": "<p><strong>Live where Carnes Crossroads comes together.</strong> From Azure Carnes Crossroads, everyday plans stay close: grocery runs at The Marketplace at Carnes Crossroads, pizza at Steel City, burgers and craft beer at Neighborhood Tap House, and coffee or bagels nearby when the day calls for something quick. Just beyond the retail spots, Carnes Crossroads brings Lowcountry character into view with ponds, trails, green spaces, and the Green Barn’s event-ready setting.</p><p>You’re also positioned near Highway 17A, Highway 176, and I-26 for easy trips toward Goose Creek, Summerville, North Charleston, or downtown Charleston. Back home, the neighborhood’s convenience pairs naturally with <a href=\"/amenities\">resort-inspired amenities</a> and polished apartment spaces that keep your downtime as appealing as your surroundings.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that turn errands, downtime, and daily routines into something easier.</strong> At Azure Carnes Crossroads, you can move from a 24/7 fitness session or yoga-room stretch to a swim in the lagoon-style saltwater pool, then settle into the sundeck, screened cabana, pavilion lounge, or greenspace with hammocks and a firepit. Practical details work just as hard: a car care center, drive-thru mail location, online rent payments, available garages and storage, and elevator access in select areas keep the day moving smoothly. Inside your Summerville apartment, granite countertops, stainless steel appliances, custom cabinetry, designer backsplash, programmable thermostats, in-home washer/dryer, and screened outdoor space add polish where you use it most. Pets get their own perks, too, including a <a href=\"/pet-policy\">paw spa</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Azure Carnes Crossroads home?</strong> Start your application online for a spacious Summerville apartment with sophisticated finishes, gourmet kitchen details, luxurious bathrooms, and inviting community spaces—all designed for the South Carolina lifestyle you’ve been looking for.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Connect with the Azure Carnes Crossroads leasing team to learn more about spacious Summerville apartments with sophisticated finishes, modern comforts, and inviting community spaces designed for easy South Carolina living.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Azure Carnes Crossroads?</strong> Start here for quick answers on leasing, community features, pet-friendly living, and the modern comforts that define these Summerville apartments. If you need more details, the leasing team is happy to help you find what you’re looking for.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that lives the way you do.</strong> Azure Carnes Crossroads offers one-, two-, and three-bedroom apartments in Summerville with options that range from streamlined and easygoing to expansive and flexible. Compare open living areas, bedroom separation, closet space, and available extras like screened-in patios or balconies, retreat views, and corridor-attached garages in select homes.</p><p>Inside, polished details make each floor plan feel elevated from the start: gourmet kitchens with granite countertops, stainless steel appliances, designer tile backsplashes, custom routed cabinetry, lofty ceilings, modern lighting, and in-home washer/dryer convenience. Browse current pricing and availability, then explore more <a href=\"/amenities\">apartment finishes</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the layouts in person.</p>",
  "property_gallery_blurb": "<p><strong>See Azure Carnes Crossroads from every angle.</strong> Browse photos that bring the setting into focus: sunlight across granite kitchen counters, custom cabinetry framed by modern lighting, open living areas with room to settle in, and screened outdoor spaces that extend your apartment into the Lowcountry air.</p><p>The gallery also gives you a feel for the community beyond your front door. Picture a lagoon-style <a href=\"/amenities\">pool and sundeck</a>, a shaded cabana, landscaped courtyard seating, and a bright social lounge with a pool table, blue sofas, and statement pendants overhead. As you explore the images, notice the mix of polished finishes and easygoing outdoor spaces that shape daily life here in Summerville. Like what you see? Take the next step with <a href=\"/virtual-tours\">virtual tours</a> or plan an in-person look.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Azure Carnes Crossroads on the map.</strong> See available Summerville apartments, then get a feel for the vibrant community around them—from modern comforts at home to social spaces, the dog park, fitness center, BBQ area, game lounge, and resort-inspired pool that shape the sweet South Carolina lifestyle here.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, rinse, and relax.</strong> At Azure Carnes Crossroads, pet-friendly apartment living means more than a policy box checked. Bring your cat or dog home to spacious layouts with no weight limit, then make daily care simpler with an on-site dog park for quick play breaks and a Paw Spa for post-adventure cleanups.</p><p>When it’s time to stretch out, landscaped greenspace, hammocks, courtyards, and nearby Carnes Crossroads paths give your routine an easy outdoor rhythm in Summerville. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Azure makes life with pets feel effortless.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Azure lifestyle.</strong> Love your spacious home, gourmet kitchen, rain shower, walk-in closet, and vibrant social spaces? Invite a friend to experience the same sophisticated comfort at Azure Carnes Crossroads—then send your referral using the form below.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong> Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying Azure’s sophisticated spaces, modern comforts, and relaxed South Carolina lifestyle.</p>",
  "property_reviews_blurb": "<p><strong>See why residents love calling Azure Carnes Crossroads home.</strong> As you read the reviews, you’ll notice consistent praise for responsive management, prompt maintenance, and a well-kept community where questions and requests are handled with care.</p><p>Residents highlight spacious apartments, convenient storage options, welcomed pets, and everyday extras like food trucks, package service, and time by the pool. Many also point to the location, with easy access to shopping in Summerville and Goose Creek. In their own words, the team is “helpful and responsive”—and that service-first experience is a recurring reason residents say they’re happy here.</p>",
  "property_created_at": "1778514850755",
  "property_scheduletour_blurb": "<p><strong>See Azure Carnes Crossroads up close.</strong> Tour spacious Summerville apartments with gourmet kitchens, designer tile backsplashes, rain shower heads, and walk-in closets—then explore the pool, game lounge, fitness center, and dog park. Schedule your visit today and picture the South Carolina lifestyle waiting at Azure.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture life at Azure Carnes Crossroads: sophisticated Summerville apartments with gourmet kitchens, spa-inspired bathrooms, walk-in closets, and inviting social spaces made for relaxing, gathering, and enjoying that sweet South Carolina lifestyle.</p>",
  "property_virtualtours_blurb": "<p><strong>Take a closer look before you visit.</strong> Explore Azure Carnes Crossroads through virtual tours that let you move at your own pace, from community spaces to apartment interiors. Start with the available community tours to get a feel for the setting, then step inside the Azure Carnes Crossroads apartment tour, Virtual Tour 5, and the three-bedroom, two-bath walkthrough.</p><p>As you click through, look for the details that matter in motion: open living areas, polished kitchen finishes, roomy closets, in-home washer/dryer convenience, and private outdoor space in select layouts. Use these tours to narrow your favorite style, compare options on the <a href=\"/floor-plans\">floor plans</a> page, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Azure in Summerville in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Azure Carnes Crossroads",
  "property_seo_title_home": "Azure Carnes Crossroads |  Apartments in Summerville, SC",
  "property_seo_description_home": "Embrace luxury living at Azure Carnes Crossroads in Summerville, SC. Choose from stylish one to three-bedroom apartments with resort-style amenities!",
  "property_seo_title_floorplans": "Floor Plans | Summerville, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Azure Carnes Crossroads in Summerville, SC. From cozy one bedrooms to spacious three bedrooms, we have a floor plan just for you!",
  "property_seo_title_amenities": "Amenities | Summerville, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Azure Carnes Crossroads in Summerville, SC. Enjoy spacious floor plans, resort-style amenities, and pet-friendly comfort.",
  "property_seo_title_gallery": "Gallery | Apartments in Summerville, SC",
  "property_seo_description_gallery": "Discover vibrant living at Azure Carnes Crossroads! Enjoy spacious, modern apartments in Summerville, SC with stunning amenities. Picture your new life!",
  "property_seo_title_virtualtours": "Virtual Tours | Azure Carnes Crossroads Apartments",
  "property_seo_description_virtualtours": "Step inside Azure Carnes Crossroads in Summerville, SC! Experience our spacious one, two, and three-bedroom apartments through a stunning virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Azure Carnes Crossroads Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Azure Carnes Crossroads in Summerville, SC. Use our interactive map to explore stunning floor plans, amenities, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Summerville, SC",
  "property_seo_description_neighborhood": "Uncover the charm of Summerville at Azure Carnes Crossroads. Dive into local favorites and vibrant points of interest just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Azure Carnes Crossroads",
  "property_seo_description_contact": "Connect with Azure Carnes Crossroads in Summerville, SC! Inquire about our one, two, and three-bedroom floor plans. Your perfect home awaits—reach out now!",
  "property_seo_title_faqs": "FAQs | Apartments in Summerville, SC",
  "property_seo_description_faqs": "Uncover answers to all your queries at Azure Carnes Crossroads. From stunning floor plans to luxurious amenities, our FAQs will guide your new home journey!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Summerville, SC",
  "property_seo_description_reviews": "Experience life at Azure Carnes Crossroads! Residents love our spacious layouts, cozy amenities, and vibrant community in Summerville, SC.",
  "property_seo_title_applynow": "Apply Now | Apartments in Summerville, SC",
  "property_seo_description_applynow": "Discover modern living at Azure Carnes Crossroads in Summerville, SC. Explore stylish floor plans and premier amenities. Apply today!",
  "property_seo_title_residentaccess": "Resident Access | Azure Carnes Crossroads",
  "property_seo_description_residentaccess": "Unlock seamless living at Azure Carnes Crossroads! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Azure Carnes Crossroads",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Azure Carnes Crossroads in Summerville, SC, and enjoy exclusive perks together in our vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Azure Carnes Crossroads",
  "property_seo_description_scheduletour": "Experience vibrant living at Azure Carnes Crossroads in Summerville, SC. Schedule a tour today to see your future home in a thriving community!",
  "property_seo_title_privacy": "Privacy Policy | Azure Carnes Crossroads",
  "property_seo_description_privacy": "At Azure Carnes Crossroads in Summerville, SC, your privacy matters. Learn how we safeguard your information. Read our privacy policy today for peace of mind.",
  "property_seo_title_accessibility": "Website Accessibility | Azure Carnes Crossroads",
  "property_seo_description_accessibility": "At Azure Carnes Crossroads in Summerville, SC, we prioritize digital inclusion. Experience accessible living tailored for everyone! Join our community today.",
  "property_seo_title_sitemap": "Sitemap | Azure Carnes Crossroads",
  "property_seo_description_sitemap": "Navigate your way through Azure Carnes Crossroads in Summerville, SC! Check out our sitemap for a seamless journey to your future home and community.",
  "property_seo_title_thankyou": "Thank You | Azure Carnes Crossroads",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to upscale living at Azure Carnes Crossroads in Summerville, SC, starts here. Expect a warm reply from our team soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234321336",
  "amenities": [
    {
      "id": "custom_ae3c20c0-e029-4f96-b9e2-359acd8ce919",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9794d506-bc95-4baa-98a1-610db588895c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Full-Size Washer & Dryer",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc4ed980-54e8-4361-bbc6-e5bac05b6711",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c203dc9-cce7-450a-b00c-06226b221c1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Gourmet Kitchens with Undermount Sink",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d4a57a0-664c-4c42-b448-29d413ed5e42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000596",
      "title": "Alarms",
      "amount": "0.0000",
      "description": "Home Intrusion Alarms with Optional Monitoring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c2d78e1-2d03-4b86-a573-6d796f6c65fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Fitness Center with Cardio, Resistance & Free Weights",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebcddb01-d5d1-4900-81c3-3a78315ae52b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2-Inch Faux Wood Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aeb19b43-c5ea-46e9-b19c-4b34ccb5c1b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Custom Routed Wood Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99ef33df-40b5-4913-83bf-42d42f68dac6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000629",
      "title": "Double Vanity",
      "amount": "0.0000",
      "description": "Framed Vanity Mirrors",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_90433479-6200-4638-9af3-9b21a9e44a15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000636",
      "title": "Fixtures",
      "amount": "0.0000",
      "description": "Modern Track & Pendant Lighting",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d90c370-72e4-425f-a817-59fdee4dbce1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garage & Storage Units Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fed8e6b3-38e2-4fc8-8f99-9a3b2f7ec4d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Upscale Wood-Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04483ea5-73f4-4252-94e0-a2a8e358dd9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Screened-In Patio or Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_105b94bf-4ff2-412f-85de-60f3c4a6a61a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8114f15c-4803-4ce7-9d6d-c08b06da6fff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000680",
      "title": "Soaking Tub",
      "amount": "0.0000",
      "description": "Spa-Inspired Bathrooms with Rain Shower Heads",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5e68ab8-7178-4732-8aa7-a9f6b9b924e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Designer Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4cc2d722-cb51-40ff-ad5a-db2d6ad089c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Soaking Tub*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a70c0fa7-f0fc-4ec9-97d4-5b07de137907",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Large Walk-In Closets*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb1463e2-5c00-44be-b0dd-a95b68005ba8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Lagoon-Style Saltwater Pool with Expansive Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fadaf2ed-3948-4a59-a553-63db26770593",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000712",
      "title": "Yoga Room",
      "amount": "0.0000",
      "description": "Yoga & Wellness Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a52406a3-2ffa-4a4f-bb16-75edb0c35eed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "On-Site Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82a3887a-d5c3-4cca-bbd5-6ae3c121a689",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000002652",
      "title": "Above Garage",
      "amount": "0.0000",
      "description": "Corridor-Attached Garages*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfe89e5c-0ba8-4d23-9c8b-c3035eba661d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Dog Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e9a9633-d9b2-4433-a07f-e8773e349a08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000627",
      "title": "Dog Spa",
      "amount": "0.0000",
      "description": "Paw Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23f406b4-07ef-4c4a-994c-caaccc5297b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000001338",
      "title": "Barbeque/Grill",
      "amount": "0.0000",
      "description": "Outdoor Grilling & Dining Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fea96c32-1083-41e8-b60b-c59feb7731df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Greenspace with Fire Pit & Hammocks",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5da899b-b2ab-48e1-a3fa-8145e4fbd38c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Social Lounge with Gaming & TV",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ffe69c4-2c2b-485a-91a3-c88139de9413",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee & Hot Tea Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_339d4582-b562-4026-9cb7-0ab3d6a791d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000679",
      "title": "Smoke Free Community",
      "amount": "0.0000",
      "description": "Smoke Free Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41135681-beed-4b3c-8dcd-c9eb5b5d1e8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Indoor & Outdoor Resident Lounges",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ed283613-f3c4-4da0-87e6-23c0f38bcb15",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000002543",
      "title": "Package Reception",
      "amount": "0.0000",
      "description": "Drive-Thru Mail Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a824853-c5f7-4206-8b56-6cee87e1f957",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a57c48b2-37b4-4b16-81e1-d0e83939b09d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7deefcd3-ed44-4568-9a7a-076d216c727f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ec4a44e2-4083-4562-8b09-de32d1775364",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-096a-760b-8038-1ce12976f95b.webp",
      "image_media": {
        "alt_text": "Sleek and modern lounge area with a tan tufted sofa, decorative pillows, and a large olive tree.",
        "public_id": "01a08796-096a-760b-8038-1ce12976f95b",
        "storage_key": "property/6767906449167486/01a08796-096a-760b-8038-1ce12976f95b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in the beautifully designed lounge, featuring plush seating and elegant decor, perfect for unwinding or socializing.",
      "link": "",
      "alt_text": "Sleek and modern lounge area with a tan tufted sofa, decorative pillows, and a large olive tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a3a7648-51f9-4007-b511-8ecd95858d69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-155d-70bb-baeb-69c48d79c28c.webp",
      "image_media": {
        "alt_text": "Azure Carnes Crossroads monument sign in front of the apartment buildings.",
        "public_id": "01a08796-155d-70bb-baeb-69c48d79c28c",
        "storage_key": "property/6767906449167486/01a08796-155d-70bb-baeb-69c48d79c28c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Azure Carnes Crossroads, a beautiful apartment community with modern exteriors and lush landscaping. Visit our monument sign to learn more.",
      "link": "",
      "alt_text": "Azure Carnes Crossroads monument sign in front of the apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b64eed2d-064b-411e-a5e4-064bd3f9c8c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-0136-7002-9b79-fe928189ffdf.webp",
      "image_media": {
        "alt_text": "Stylish living room with a curved sofa and accent wall.",
        "public_id": "01a08796-0136-7002-9b79-fe928189ffdf",
        "storage_key": "property/6767906449167486/01a08796-0136-7002-9b79-fe928189ffdf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully designed apartment living room, featuring a plush curved sofa and a unique accent wall.",
      "link": "",
      "alt_text": "Stylish living room with a curved sofa and accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd045e03-9a8e-41ab-be78-273273fe3974",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-01f4-74c8-8b5a-66a0f1325eb3.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, modern art accent wall, and large windows.",
        "public_id": "01a08796-01f4-74c8-8b5a-66a0f1325eb3",
        "storage_key": "property/6767906449167486/01a08796-01f4-74c8-8b5a-66a0f1325eb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this elegantly appointed bedroom, featuring a plush king-size bed, a statement art wall, and ample natural light. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, modern art accent wall, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f36f514-e951-43db-8bc0-a64a66e6ed7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-13d2-779b-beea-4ade4b3e5e93.webp",
      "image_media": {
        "alt_text": "Indoor game area with shuffleboard and ping pong tables, comfortable seating, and TVs.",
        "public_id": "01a08796-13d2-779b-beea-4ade4b3e5e93",
        "storage_key": "property/6767906449167486/01a08796-13d2-779b-beea-4ade4b3e5e93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy indoor recreation with shuffleboard and ping pong tables, perfect for friendly competition or relaxation. This communal space offers comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "Indoor game area with shuffleboard and ping pong tables, comfortable seating, and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ba5d82e-69d8-4360-9978-90cee4a43e8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08796-11b3-701c-9e05-286e40079ce4.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with bar seating and a flat-screen TV.",
        "public_id": "01a08796-11b3-701c-9e05-286e40079ce4",
        "storage_key": "property/6767906449167486/01a08796-11b3-701c-9e05-286e40079ce4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a stylish kitchen area perfect for entertaining, featuring bar seating, a flat-screen TV, and modern decor.",
      "link": "",
      "alt_text": "Modern kitchen area with bar seating and a flat-screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3fa9bb2-afad-40ec-950c-1d9463b7f121",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-e640-744d-8270-ec74fcfbd6a5.webp",
      "image_media": {
        "alt_text": "Community lounge area with a billiard table, Scrabble board, and comfortable seating.",
        "public_id": "01a08795-e640-744d-8270-ec74fcfbd6a5",
        "storage_key": "property/6767906449167486/01a08795-e640-744d-8270-ec74fcfbd6a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in the community lounge, featuring a billiard table, Scrabble board, and elegant seating arrangements for relaxation and socializing.",
      "link": "",
      "alt_text": "Community lounge area with a billiard table, Scrabble board, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_48feeff3-0a5c-4ccb-a9ca-dd3bc7e50a78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-e4c3-72df-8819-2337d5ba1be0.webp",
      "image_media": {
        "alt_text": "Outdoor balcony seating area with two chairs, a small table, and plants.",
        "public_id": "01a08795-e4c3-72df-8819-2337d5ba1be0",
        "storage_key": "property/6767906449167486/01a08795-e4c3-72df-8819-2337d5ba1be0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this charming balcony, complete with comfortable seating and lush greenery.",
      "link": "",
      "alt_text": "Outdoor balcony seating area with two chairs, a small table, and plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21c2c785-1c0b-4c34-bb41-6e618f0a775d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-d52c-73bf-8f20-d3eee6124400.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with double sinks, granite countertops, and a walk-in closet.",
        "public_id": "01a08795-d52c-73bf-8f20-d3eee6124400",
        "storage_key": "property/6767906449167486/01a08795-d52c-73bf-8f20-d3eee6124400.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Luxurious bathroom featuring a double vanity with granite countertops, ample storage, and a spacious walk-in closet, all designed for modern living.",
      "link": "",
      "alt_text": "Modern bathroom vanity with double sinks, granite countertops, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f77d897e-a122-4095-ac17-489aafd89ff3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-c88e-75ec-86e5-b7c759b69f84.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area in apartment with stainless steel appliances.",
        "public_id": "01a08795-c88e-75ec-86e5-b7c759b69f84",
        "storage_key": "property/6767906449167486/01a08795-c88e-75ec-86e5-b7c759b69f84.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and stylish kitchen and dining area, perfect for entertaining or everyday living, featuring modern finishes and ample counter space.",
      "link": "",
      "alt_text": "Modern kitchen and dining area in apartment with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_caa83561-3684-49ce-8585-46f5dd88048d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-d1f2-7552-ae0e-f93eabea4ee4.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and a business center.",
        "public_id": "01a08795-d1f2-7552-ae0e-f93eabea4ee4",
        "storage_key": "property/6767906449167486/01a08795-d1f2-7552-ae0e-f93eabea4ee4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and work in our stylish community lounge, featuring comfortable seating and a fully equipped business center with computers and printers.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and a business center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f57b188-5ec8-4599-afa8-f34d8ef2c1c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-ca23-71f3-a73b-fcd935dbd5c3.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large wooden dresser, a king-size bed with checkered pillows, and a textured wall art.",
        "public_id": "01a08795-ca23-71f3-a73b-fcd935dbd5c3",
        "storage_key": "property/6767906449167486/01a08795-ca23-71f3-a73b-fcd935dbd5c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our beautifully appointed bedrooms. Featuring modern furnishings and tasteful decor, our apartments offer a serene retreat.",
      "link": "",
      "alt_text": "Stylish bedroom with a large wooden dresser, a king-size bed with checkered pillows, and a textured wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0aa24ade-7f46-46ce-86f7-ed1fd08fa722",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-b25c-734b-ad16-defe9354e8ad.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge with blue velvet sofas, modern tables, and large potted olive trees.",
        "public_id": "01a08795-b25c-734b-ad16-defe9354e8ad",
        "storage_key": "property/6767906449167486/01a08795-b25c-734b-ad16-defe9354e8ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Step into our elegant community lounge, designed for relaxation and socializing. Featuring plush seating, sophisticated decor, and lush greenery, it's the perfect space to unwind.",
      "link": "",
      "alt_text": "Luxurious community lounge with blue velvet sofas, modern tables, and large potted olive trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0922792b-7855-457f-9124-16b3fc0b8584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-a69a-76fa-9511-121d6a0b4770.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "01a08795-a69a-76fa-9511-121d6a0b4770",
        "storage_key": "property/6767906449167486/01a08795-a69a-76fa-9511-121d6a0b4770.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully appointed kitchen featuring granite countertops, stainless steel appliances, ample cabinet space, and a breakfast bar with seating. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d89258af-1be7-4f32-a2ae-1a716412721d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-a198-74c4-a250-c2398a82847c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
        "public_id": "01a08795-a198-74c4-a250-c2398a82847c",
        "storage_key": "property/6767906449167486/01a08795-a198-74c4-a250-c2398a82847c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom, featuring a granite countertop vanity, a comfortable bathtub, and elegant tilework. A perfect retreat for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97c4ee89-d985-47c0-8caf-49c03a0f9d1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-a8f2-73ac-982a-5f191ee0c9c2.webp",
      "image_media": {
        "alt_text": "Stylish living room with abstract wall art, modern furniture, and a view into the kitchen.",
        "public_id": "01a08795-a8f2-73ac-982a-5f191ee0c9c2",
        "storage_key": "property/6767906449167486/01a08795-a8f2-73ac-982a-5f191ee0c9c2.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Discover the spacious and artfully designed living areas, featuring contemporary furniture and an open-concept layout flowing seamlessly into the kitchen.",
      "link": "",
      "alt_text": "Stylish living room with abstract wall art, modern furniture, and a view into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_77fa38d2-2d72-4f51-997d-1d249ae64dd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/01a08795-9cf3-7715-83d3-719d2f22ecde.webp",
      "image_media": {
        "alt_text": "Swimming pool and resort-style lounge areas at an apartment complex.",
        "public_id": "01a08795-9cf3-7715-83d3-719d2f22ecde",
        "storage_key": "property/6767906449167486/01a08795-9cf3-7715-83d3-719d2f22ecde.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and cabanas, at this premier apartment community.",
      "link": "",
      "alt_text": "Swimming pool and resort-style lounge areas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31c98404-3287-45bc-afb6-4662945a4957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e890f-5b9f-762d-9d5c-8ba6005c0639.webp",
      "image_media": {
        "alt_text": "Treadmills and cardio machines in a well-lit fitness center.",
        "public_id": "019e890f-5b9f-762d-9d5c-8ba6005c0639",
        "storage_key": "property/6767906449167486/019e890f-5b9f-762d-9d5c-8ba6005c0639.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, ellipticals, and stair climbers.",
      "link": "",
      "alt_text": "Treadmills and cardio machines in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_135d4b55-7bbd-475d-8917-7e8c4843de2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e890f-5b47-76ca-853e-4616dcd7266f.webp",
      "image_media": {
        "alt_text": "Pathway leading to community buildings with palm trees and lush landscaping at dusk.",
        "public_id": "019e890f-5b47-76ca-853e-4616dcd7266f",
        "storage_key": "property/6767906449167486/019e890f-5b47-76ca-853e-4616dcd7266f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover the serene ambiance of our community grounds, featuring well-lit pathways, mature palm trees, and beautifully manicured lawns, perfect for evening strolls.",
      "link": "",
      "alt_text": "Pathway leading to community buildings with palm trees and lush landscaping at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e844b16-b99b-4c06-ad68-ce96ce06d68f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e890f-5725-74cb-9000-13752e075c29.webp",
      "image_media": {
        "alt_text": "Yoga studio with ballet bar, TV, and yoga mats.",
        "public_id": "019e890f-5725-74cb-9000-13752e075c29",
        "storage_key": "property/6767906449167486/019e890f-5725-74cb-9000-13752e075c29.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Engage in your wellness journey in our dedicated yoga studio, complete with a ballet bar, large screen TV, and yoga mats for your practice.",
      "link": "",
      "alt_text": "Yoga studio with ballet bar, TV, and yoga mats.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1175947-51a7-4e27-a6e4-edd2a71fc415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e890f-4914-725c-8715-4c15d1c990e9.webp",
      "image_media": {
        "alt_text": "Modern apartment building courtyard with fire pit, seating, and outdoor grills.",
        "public_id": "019e890f-4914-725c-8715-4c15d1c990e9",
        "storage_key": "property/6767906449167486/019e890f-4914-725c-8715-4c15d1c990e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a spacious courtyard featuring a fire pit, comfortable seating, and built-in grills, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern apartment building courtyard with fire pit, seating, and outdoor grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_33da8569-4d6f-4a59-ab2e-2b5ed7773d26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e890f-3ff4-74b3-b1db-2ad6db532dad.webp",
      "image_media": {
        "alt_text": "Modern gym with weight machines, free weights, and treadmills.",
        "public_id": "019e890f-3ff4-74b3-b1db-2ad6db532dad",
        "storage_key": "property/6767906449167486/019e890f-3ff4-74b3-b1db-2ad6db532dad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of TKO weight machines, a squat rack, free weights, and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern gym with weight machines, free weights, and treadmills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_b63c8c0667d38438b811da1c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "East Bay Deli - Summerville",
      "poi_type": "Restaurants",
      "poi_address": "2519 N Main St B, Summerville, SC 29486, USA",
      "poi_short_description": "Casual eatery dishing up deli-style sandwiches and burgers as well as salads, soup and sides.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-df63-77bc-85f3-7c4b4b65ca0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-df63-77bc-85f3-7c4b4b65ca0a",
        "storage_key": "property/6767906449167486/019e7441-df63-77bc-85f3-7c4b4b65ca0a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.eastbaydeli.com/location/summerville-crossroads-crossing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16763253033203419156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-bay-deli---summerville",
      "poi_latitude": "33.0583724",
      "poi_longitude": "-80.0969793",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 843-471-2444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aefe-77aa-8ba6-97ed51bea648",
        "storage_key": "property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnwjr8Kz1_ogRFEgUdNEJo-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "ec_8864717bb8f7f43d9070d4b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "El Jalapeño - at Carnes Crossroads",
      "poi_type": "Restaurants",
      "poi_address": "2507 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Casual eatery dishing up classic Mexican fare such as burritos, enchiladas and tacos alongside margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-58af-757a-a477-9251d5513091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-58af-757a-a477-9251d5513091",
        "storage_key": "property/6767906449167486/019e17c1-58af-757a-a477-9251d5513091.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eljalapenomexicangrill.godaddysites.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5615204331489231452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-jalapeo---at-carnes-crossroads",
      "poi_latitude": "33.0572306",
      "poi_longitude": "-80.09806460000001",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-900-3795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcw1jUPf1_ogRXIKmv5Y27U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_451627377119a9829f3d8165",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Steel City Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2511 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Casual eatery showing sports on HD TVs along with a menu of pizza, burgers, wings & sandwiches.",
      "poi_long_description": "Casual eatery showing sports on HD TVs along with a menu of pizza, burgers, wings & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-54bf-731f-82e9-548bca93f52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-54bf-731f-82e9-548bca93f52d",
        "storage_key": "property/6767906449167486/019e17c1-54bf-731f-82e9-548bca93f52d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://steelcitypizza.com/charleston-steel-city-pizza-company-locations-summerville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5724541455811726319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steel-city-pizza",
      "poi_latitude": "33.0578016",
      "poi_longitude": "-80.0973369",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 843-867-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76M5jEL1_ogR78unxx-ocU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_a123f7021a89a97428cbfb24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Firehouse Subs Carnes Crossroads",
      "poi_type": "Restaurants",
      "poi_address": "2680 N Main St Suite 110, Summerville, SC 29486, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-1cb6-77cb-a206-7296ab3eaa78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-1cb6-77cb-a206-7296ab3eaa78",
        "storage_key": "property/6767906449167486/019e8434-1cb6-77cb-a206-7296ab3eaa78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13063624559831683101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-carnes-crossroads",
      "poi_latitude": "33.0619604",
      "poi_longitude": "-80.09663859999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-376-3014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyMj329f_ogRHRDWt1JRS7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_3475b34542eeaacff5b686ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Mai Poke - Carnes Crossroads",
      "poi_type": "Restaurants",
      "poi_address": "102 Gosling Wy A, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-e21a-77c2-9274-591cea4f84d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-e21a-77c2-9274-591cea4f84d9",
        "storage_key": "property/6767906449167486/019e7441-e21a-77c2-9274-591cea4f84d9.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.maipoke.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1980373663625539363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mai-poke---carnes-crossroads",
      "poi_latitude": "33.055366",
      "poi_longitude": "-80.099069",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 854-269-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQSgk6b1_ogRI2_wxlqzexs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "ec_04b33a2f41de400b34bbc08d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Ruby's NY Style Bagels",
      "poi_type": "Restaurants",
      "poi_address": "2680 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-1ad5-7528-9852-1bd610f57e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-1ad5-7528-9852-1bd610f57e69",
        "storage_key": "property/6767906449167486/019e8434-1ad5-7528-9852-1bd610f57e69.webp",
        "width": 1050,
        "height": 1280
      },
      "poi_business_url": "https://www.rubysnystylebagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5834611740344031019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rubys-ny-style-bagels",
      "poi_latitude": "33.062181",
      "poi_longitude": "-80.096216",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-285-5902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8Zjl_1f_ogRK5eH-Xa0-FA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_7eee31ce373cfb35004c72ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "StillWild Coffee Co",
      "poi_type": "Restaurants",
      "poi_address": "100 S Main St Ste A, Summerville, SC 29483, USA",
      "poi_short_description": "Busy coffee shop offering specialty drinks, small plates, and baked goods, plus live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-e345-75ef-8bba-7d4457bb7881.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-e345-75ef-8bba-7d4457bb7881",
        "storage_key": "property/6767906449167486/019e7441-e345-75ef-8bba-7d4457bb7881.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stillwild.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2345995904291422540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwild-coffee-co",
      "poi_latitude": "33.0201485",
      "poi_longitude": "-80.1756284",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-900-5840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aec8-7473-b0a8-895ca938e64b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aec8-7473-b0a8-895ca938e64b",
        "storage_key": "property/6767906449167486/019e17c1-aec8-7473-b0a8-895ca938e64b.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJGQhvj2-L_ogRTMHPZ9imjiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_b67e1879e73b6936a9197047",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Five Loaves Cafe",
      "poi_type": "Restaurants",
      "poi_address": "214 N Cedar St, Summerville, SC 29483, USA",
      "poi_short_description": "Casual, family-friendly eatery specializing in sandwiches, soups and salads, plus beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-1b97-7411-8809-676d1ab77917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-1b97-7411-8809-676d1ab77917",
        "storage_key": "property/6767906449167486/019e8434-1b97-7411-8809-676d1ab77917.webp",
        "width": 1023,
        "height": 1280
      },
      "poi_business_url": "https://www.fiveloavescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8488536591367676018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-loaves-cafe",
      "poi_latitude": "33.0235374",
      "poi_longitude": "-80.17496640000002",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-804-9410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Vl7v2iL_ogRciBgPw5XzXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_18eb9b446af6990870e7da8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "1097 N Main St #202, Summerville, SC 29483, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-1a3f-7363-9b16-5325cdfca973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-1a3f-7363-9b16-5325cdfca973",
        "storage_key": "property/6767906449167486/019e8434-1a3f-7363-9b16-5325cdfca973.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firstwatch.com/locations/summerville/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=summerville",
      "poi_directions_map_url": "https://maps.google.com/?cid=548615802532637607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "33.0322186",
      "poi_longitude": "-80.1637465",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 843-790-0880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsaqggX6L_ogRp6sfbCoTnQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_4e27b768b6ae0f3f3ed8604e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Halls Chophouse Nexton (Summerville)",
      "poi_type": "Restaurants",
      "poi_address": "300 Nexton Square Dr, Summerville, SC 29486, USA",
      "poi_short_description": "High-end New American eatery serving steaks & seafood in elegant surroundings with outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-0163-75ee-a3f1-79da75dba752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17bf-0163-75ee-a3f1-79da75dba752",
        "storage_key": "property/6767906449167486/019e17bf-0163-75ee-a3f1-79da75dba752.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://hallschophousenexton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11300976621202609621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halls-chophouse-nexton-summerville",
      "poi_latitude": "33.0418281",
      "poi_longitude": "-80.1409376",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-900-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX5zDMcWL_ogR1ZXGoVwi1Zw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a767cfab6809ef80f0769719",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Bexley Fish & Raw Bar",
      "poi_type": "Restaurants",
      "poi_address": "100 W Richardson Ave Suite A, Summerville, SC 29483, USA",
      "poi_short_description": "Seafood-focused cafe featuring creatively plated dishes such as bone marrow and tuna crudo, plus a wine list.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-deb0-70bd-a564-11179c76db14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-deb0-70bd-a564-11179c76db14",
        "storage_key": "property/6767906449167486/019e7441-deb0-70bd-a564-11179c76db14.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.bexleysummerville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2323854344711956441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bexley-fish--raw-bar",
      "poi_latitude": "33.0189749",
      "poi_longitude": "-80.17641379999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-900-3793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8y9LjgSL_ogR2edN1jb9PyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_ee75815f40bcbfa0b5812ec8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Swig & Swine",
      "poi_type": "Restaurants",
      "poi_address": "1990 Old Trolley Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Ribs and brisket are prepared in a smoke-kissed, low-and-slow style at this Southern-accented eatery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-5c83-73e8-86fa-6f156a44b9c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-5c83-73e8-86fa-6f156a44b9c2",
        "storage_key": "property/6767906449167486/019e17c1-5c83-73e8-86fa-6f156a44b9c2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://swigandswinebbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16532726305276198668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swig--swine",
      "poi_latitude": "32.9536873",
      "poi_longitude": "-80.1665115",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-974-8688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1wm6l2J_ogRDH--AvsKcOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_d8b083cf7a2074ea12e866ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Shuckin' Shack Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "114 Central Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Family-friendly hub for steamed & raw shellfish, wings & beers served in a no-frills setting.",
      "poi_long_description": "Family-friendly hub for steamed & raw shellfish, wings & beers served in a no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-1eb5-736d-bebf-bf53ac77726e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-1eb5-736d-bebf-bf53ac77726e",
        "storage_key": "property/6767906449167486/019e8434-1eb5-736d-bebf-bf53ac77726e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.theshuckinshack.com/location-summerville",
      "poi_directions_map_url": "https://maps.google.com/?cid=368695167424166738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shuckin-shack-oyster-bar",
      "poi_latitude": "33.019128",
      "poi_longitude": "-80.1773776",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-879-2422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVY5cmWL_ogRUnu4JE3eHQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_e1eb27d599e8cf233510e79e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Matt's Burgers",
      "poi_type": "Restaurants",
      "poi_address": "102 S Cedar St B, Summerville, SC 29483, USA",
      "poi_short_description": "Tiny, old-school spot offering classic & specialty burgers, chili, fries & other comfort fare.",
      "poi_long_description": "Tiny, old-school spot offering classic & specialty burgers, chili, fries & other comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-59d2-728a-a49a-0707777c7678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-59d2-728a-a49a-0707777c7678",
        "storage_key": "property/6767906449167486/019e17c1-59d2-728a-a49a-0707777c7678.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mattsburgerschs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161800877986561538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "matts-burgers",
      "poi_latitude": "33.0209773",
      "poi_longitude": "-80.17715319999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-821-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c6-7090-ae49-ba3c80ea4ab5",
        "storage_key": "property/6767906449167486/019e17bf-21c6-7090-ae49-ba3c80ea4ab5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSbOOjGWL_ogRAj4UfUAdg1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_678b798d74c2f4c49c56e4ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Montreux Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "127 W Richardson Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Relaxed hangout featuring a sizable beer list, burgers & other pub grub, plus a patio with a bar.",
      "poi_long_description": "Relaxed hangout featuring a sizable beer list, burgers & other pub grub, plus a patio with a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-78c2-77bb-9113-adb0ff4b23aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-78c2-77bb-9113-adb0ff4b23aa",
        "storage_key": "property/6767906449167486/019e17c1-78c2-77bb-9113-adb0ff4b23aa.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://montreuxbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15777595227584798198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montreux-bar--grill",
      "poi_latitude": "33.01974440000001",
      "poi_longitude": "-80.17673889999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-695-8125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aecf-70b4-904f-8cf2b297e8ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aecf-70b4-904f-8cf2b297e8ab",
        "storage_key": "property/6767906449167486/019e17c1-aecf-70b4-904f-8cf2b297e8ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTKPgWWL_ogR9h0XJkRH9do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_7ed0c9b62ff3d0941f070eee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Publix Super Market at The Market Place at Carnes Crossroads",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 N Main St a, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-e6da-7516-b1ad-47fadcc8e020.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-e6da-7516-b1ad-47fadcc8e020",
        "storage_key": "property/6767906449167486/019e7441-e6da-7516-b1ad-47fadcc8e020.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?utm_medium=maps&utm_source=google&utm_content=psm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=2201404786432732852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-market-place-at-carnes-crossroads",
      "poi_latitude": "33.06274550000001",
      "poi_longitude": "-80.0962393",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-879-5076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeeb-7059-a121-3eef0e79e190",
        "storage_key": "property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi8LLBspf_ogRtO4qXv31jB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_82ca6243d7d59d9dbc7a9536",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1269 Nexton Pkwy, Summerville, SC 29486, USA",
      "poi_short_description": "Grocery store.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e743f-c7ec-77f6-b2f1-6a710394f00c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e743f-c7ec-77f6-b2f1-6a710394f00c",
        "storage_key": "property/6767906449167486/019e743f-c7ec-77f6-b2f1-6a710394f00c.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/sc/summerville/nexton/097/00368?cid=loc_09700368_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4242030564247593087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "33.0591656",
      "poi_longitude": "-80.1509349",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-974-9465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeeb-7059-a121-3eef0e79e190",
        "storage_key": "property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4oMFgD1_ogRf-BTrFK43jo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1678bb9aae56802445dc32f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 N Main St, Summerville, SC 29483, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-61ad-7085-b157-db99a19c1713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-61ad-7085-b157-db99a19c1713",
        "storage_key": "property/6767906449167486/019e17c1-61ad-7085-b157-db99a19c1713.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/sc/summerville/1001-n-main-street/f911",
      "poi_directions_map_url": "https://maps.google.com/?cid=10675211021752302036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.0307469",
      "poi_longitude": "-80.1654362",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeeb-7059-a121-3eef0e79e190",
        "storage_key": "property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWsXZxmL_ogR1HnhVd33JZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_61936e7f3e7cd13252a5177a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1625 N Main St #108, Summerville, SC 29483, USA",
      "poi_short_description": "Chain grocery store with a bakery and a deli, plus fresh produce.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-606d-72bf-9efd-7b617cf584e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-606d-72bf-9efd-7b617cf584e4",
        "storage_key": "property/6767906449167486/019e17c1-606d-72bf-9efd-7b617cf584e4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stores.foodlion.com/sc/summerville/1625-n.-main-st.?y_source=1_MjI1NjA4MjgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14268814480981388850&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "33.0389357",
      "poi_longitude": "-80.13729889999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-875-2880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeeb-7059-a121-3eef0e79e190",
        "storage_key": "property/6767906449167486/019e17c1-aeeb-7059-a121-3eef0e79e190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzgavS-L_ogRMm7YyCsDBcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_77755493076c5f0cee6cb419",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1941 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-80f5-75db-a2bb-aa31e43044ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-80f5-75db-a2bb-aa31e43044ca",
        "storage_key": "property/6767906449167486/019e17c1-80f5-75db-a2bb-aa31e43044ca.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/summerville-sc-pharmacies/1941-n-main-st-summerville-sc-29483/storeid=5580?WT.mc_id=LS_GOOGLE_RX_5580",
      "poi_directions_map_url": "https://maps.google.com/?cid=6247222242215502813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.043343",
      "poi_longitude": "-80.12042439999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-875-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aee8-73be-9e88-d9af108edc6c",
        "storage_key": "property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaygugGOM_ogR3aMstIeXslY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4a6bf26d7cdefd8ff1fd8d4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1120 N Main St, Summerville, SC 29483, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-8583-77bd-96ea-5eaff4f03acf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-8583-77bd-96ea-5eaff4f03acf",
        "storage_key": "property/6767906449167486/019e17c1-8583-77bd-96ea-5eaff4f03acf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1120+n+main+st-summerville-sc-29483/id=1072",
      "poi_directions_map_url": "https://maps.google.com/?cid=14182621272090188611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.0345352",
      "poi_longitude": "-80.1611724",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-821-7537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_-6NzqL_ogRQ5vVeufK0sQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_2ac52525a55f1c0fef42c717",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1677 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-6276-748c-91a7-d0265045b1d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-6276-748c-91a7-d0265045b1d2",
        "storage_key": "property/6767906449167486/019e17c1-6276-748c-91a7-d0265045b1d2.webp",
        "width": 1280,
        "height": 1081
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/summerville/1677-n-main/2720448?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=737062528231324962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "33.040574",
      "poi_longitude": "-80.1348359",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 843-871-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-af10-7162-afd1-0ae5ea3bc35b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-af10-7162-afd1-0ae5ea3bc35b",
        "storage_key": "property/6767906449167486/019e17c1-af10-7162-afd1-0ae5ea3bc35b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJgU8rcdGK_ogRIr163HaSOgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_2343e1e168028d32e019b5d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Spinx",
      "poi_type": "Shopping & Retail",
      "poi_address": "2160 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "Gas station with a convenience store, car wash, and fried chicken, plus Wi-Fi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-22f7-75de-b4f9-70cb4a8fac39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-22f7-75de-b4f9-70cb4a8fac39",
        "storage_key": "property/6767906449167486/019e8434-22f7-75de-b4f9-70cb4a8fac39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.myspinx.com/2160-north-main-street/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17250242568415106734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spinx",
      "poi_latitude": "33.0470883",
      "poi_longitude": "-80.10950969999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 843-695-6498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-af10-7162-afd1-0ae5ea3bc35b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-af10-7162-afd1-0ae5ea3bc35b",
        "storage_key": "property/6767906449167486/019e17c1-af10-7162-afd1-0ae5ea3bc35b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJuRC5XU31_ogRrla0YzgsZe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_6d66796d013f8bec5014a05e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "The Marketplace Carnes Crossroads",
      "poi_type": "Shopping & Retail",
      "poi_address": "2680 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-22c1-772e-b376-adba3292a12a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-22c1-772e-b376-adba3292a12a",
        "storage_key": "property/6767906449167486/019e8434-22c1-772e-b376-adba3292a12a.webp",
        "width": 940,
        "height": 670
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2511433551360339569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-marketplace-carnes-crossroads",
      "poi_latitude": "33.0613613",
      "poi_longitude": "-80.09605490000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aefe-77aa-8ba6-97ed51bea648",
        "storage_key": "property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbYc7aABf_ogRca7UQYJn2iI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_74bb9b207c2b9bf9d748f742",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9880 Dorchester Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Department store offering a wide range of merchandise, including electronics, home furnishings, and clothing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-e68e-7569-8d21-8af7772ea43a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-e68e-7569-8d21-8af7772ea43a",
        "storage_key": "property/6767906449167486/019e7441-e68e-7569-8d21-8af7772ea43a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/628-summerville-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1830343504331983125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.950211",
      "poi_longitude": "-80.15524359999999",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 843-871-3303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aefe-77aa-8ba6-97ed51bea648",
        "storage_key": "property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8QC-hWWJ_ogRFcmmOLivZhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_9d8241ef1619dd122fbdc949",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Carolyn Lewis K8 School",
      "poi_type": "Education",
      "poi_address": "380 Coleridge Dr, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-68b8-722b-9c58-406bb3393600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-68b8-722b-9c58-406bb3393600",
        "storage_key": "property/6767906449167486/019e17c1-68b8-722b-9c58-406bb3393600.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bcsdschools.net/o/cls",
      "poi_directions_map_url": "https://maps.google.com/?cid=6108650356831004739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolyn-lewis-k8-school",
      "poi_latitude": "33.0679455",
      "poi_longitude": "-80.10346510000001",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-900-3302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiUYs9Ez1_ogRQ6j5byJJxlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_21c052d0106bb6c4c0f4e0c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Cane Bay Elementary School",
      "poi_type": "Education",
      "poi_address": "1247 Cane Bay Blvd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-6b62-772f-879e-aee4705871f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-6b62-772f-879e-aee4705871f1",
        "storage_key": "property/6767906449167486/019e17c1-6b62-772f-879e-aee4705871f1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.bcsdschools.net/o/cbe",
      "poi_directions_map_url": "https://maps.google.com/?cid=13246060504234951666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cane-bay-elementary-school",
      "poi_latitude": "33.108256",
      "poi_longitude": "-80.1209525",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-899-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKT6omqsEVYgR8oNBFNl107c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5c796fbcada47c4311a8f72f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Cane Bay Middle School",
      "poi_type": "Education",
      "poi_address": "1175 Cane Bay Blvd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bcsdschools.net/o/cbm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15017342448711886064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cane-bay-middle-school",
      "poi_latitude": "33.1062207",
      "poi_longitude": "-80.120475",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 843-899-1857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVdZLHJb1_ogR8OTdTWRRaNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_328271e49be19c59e46d0c48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Cane Bay High School",
      "poi_type": "Education",
      "poi_address": "1624 State Rd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-6dc9-73f7-9e0b-e850bb574576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-6dc9-73f7-9e0b-e850bb574576",
        "storage_key": "property/6767906449167486/019e17c1-6dc9-73f7-9e0b-e850bb574576.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bcsdschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9940430812919212770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cane-bay-high-school",
      "poi_latitude": "33.1020144",
      "poi_longitude": "-80.1222531",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 843-899-8786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8Vo23Jf1_ogR4qplXiiB84k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_340a433f4ae52169adeb95ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Big Blue Marble Academy Cane Bay",
      "poi_type": "Education",
      "poi_address": "1742 State Rd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bbmacademy.com/location/cane-bay/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1668639341456998760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-blue-marble-academy-cane-bay",
      "poi_latitude": "33.106893",
      "poi_longitude": "-80.126746",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 854-333-9525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv7f4FAD1_ogRaEHJ5aMyKBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_987c366421cb09ed8a8afe0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "The Goddard School of Summerville",
      "poi_type": "Education",
      "poi_address": "110 Connectivity Ln, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-70cb-74fa-b81c-0878f4d4d249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-70cb-74fa-b81c-0878f4d4d249",
        "storage_key": "property/6767906449167486/019e17c1-70cb-74fa-b81c-0878f4d4d249.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goddardschool.com/schools/sc/summerville/summerville?utm_source=google&utm_medium=business_listings&utm_campaign=school&utm_content=main_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=1340531985418487165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-goddard-school-of-summerville",
      "poi_latitude": "33.0512887",
      "poi_longitude": "-80.1483317",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-585-0110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZh5O1v1_ogRfQXrAL2GmhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a4c4be1a775eab4a841abd79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Nexton KinderCare",
      "poi_type": "Education",
      "poi_address": "310 Brighton Park Blvd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-6d5b-72a8-9921-54af07eefd11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-6d5b-72a8-9921-54af07eefd11",
        "storage_key": "property/6767906449167486/019e17c1-6d5b-72a8-9921-54af07eefd11.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/summerville/sc/086135?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MTQ5ODY0MDYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1435561900814177778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nexton-kindercare",
      "poi_latitude": "33.0429961",
      "poi_longitude": "-80.1421974",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-821-7744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUwp70_6L_ogR8hUdX_Ej7BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_cf9ebb7516b5125fd64f525f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Ridge Christian Academy",
      "poi_type": "Education",
      "poi_address": "2168 Ridge Church Rd, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ridgechristian.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13197290216399070077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridge-christian-academy",
      "poi_latitude": "33.0414487",
      "poi_longitude": "-80.11115269999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 843-873-9856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_l-P7KK_ogRfWM0kocxJrc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_62e4188d2e5611c6f28dcb14",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Pinewood Preparatory School",
      "poi_type": "Education",
      "poi_address": "1114 Orangeburg Rd, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-2b37-712d-a9a0-f17f850eae25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-2b37-712d-a9a0-f17f850eae25",
        "storage_key": "property/6767906449167486/019e8434-2b37-712d-a9a0-f17f850eae25.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pinewoodprep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6596959838914402428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinewood-preparatory-school",
      "poi_latitude": "33.0249089",
      "poi_longitude": "-80.2408531",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 843-873-1643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwnCMxqN_ogRfNgCdAUcjVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ce127a917a8eae76f868f177",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Trident Technical College Dorchester Campus",
      "poi_type": "Education",
      "poi_address": "10055 Dorchester Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-a34c-702c-bc89-9c209ed8fa32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-a34c-702c-bc89-9c209ed8fa32",
        "storage_key": "property/6767906449167486/019e17c1-a34c-702c-bc89-9c209ed8fa32.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tridenttech.edu/about/locations/dorchester/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12832939076197151377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trident-technical-college-dorchester-campus",
      "poi_latitude": "32.9512901",
      "poi_longitude": "-80.16492459999999",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 843-574-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGz-nXHSJ_ogRkfL1FBnCF7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_7700907af515b2fe17271bb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Regal Azalea Square",
      "poi_type": "Entertainment",
      "poi_address": "215 Azalea Square Blvd, Summerville, SC 29483, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-7468-775c-836d-d9948db3ed8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-7468-775c-836d-d9948db3ed8e",
        "storage_key": "property/6767906449167486/019e17c1-7468-775c-836d-d9948db3ed8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-azalea-square-rpx-1850?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10916881957278998755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-azalea-square",
      "poi_latitude": "33.03669259999999",
      "poi_longitude": "-80.16056669999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-d7b8d725ea00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-d7b8d725ea00",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-d7b8d725ea00.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx287TmL_ogR42B8zkyOgJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_f6540c8f01ee5bebe45babab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Azalea Park",
      "poi_type": "Entertainment",
      "poi_address": "105 W 5th S St, Summerville, SC 29483, USA",
      "poi_short_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_long_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-18cb-746b-881c-26363eeb900a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17bf-18cb-746b-881c-26363eeb900a",
        "storage_key": "property/6767906449167486/019e17bf-18cb-746b-881c-26363eeb900a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/196/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16921181544976970789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azalea-park",
      "poi_latitude": "33.0143515",
      "poi_longitude": "-80.1774669",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fBkAnuL_ogRJXQ_gPYc1Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_54ab672f6319e6ab5606a1be",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Summerville Museum & Research Center",
      "poi_type": "Entertainment",
      "poi_address": "100 E Doty Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Museum of county history in a former police station with exhibits, artifacts & community events.",
      "poi_long_description": "Museum of county history in a former police station with exhibits, artifacts & community events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-0695-721f-b579-109b794d191b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17bf-0695-721f-b579-109b794d191b",
        "storage_key": "property/6767906449167486/019e17bf-0695-721f-b579-109b794d191b.webp",
        "width": 1124,
        "height": 1280
      },
      "poi_business_url": "https://summervillemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000764324654083437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summerville-museum--research-center",
      "poi_latitude": "33.0196153",
      "poi_longitude": "-80.1746173",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-875-9666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c5-77b1-801b-91f7bc03f343.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c5-77b1-801b-91f7bc03f343",
        "storage_key": "property/6767906449167486/019e17bf-21c5-77b1-801b-91f7bc03f343.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJsR7MDG-L_ogRbe2_qWAiDt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_1ea657734ce6c9c1a4d5ef50",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Colonial Dorchester State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "300 State Park Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_long_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-7979-76af-8b60-55f6e75f9da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-7979-76af-8b60-55f6e75f9da7",
        "storage_key": "property/6767906449167486/019e17c1-7979-76af-8b60-55f6e75f9da7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.southcarolinaparks.com/colonialdorchester",
      "poi_directions_map_url": "https://maps.google.com/?cid=13989591396413956151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-dorchester-state-historic-site",
      "poi_latitude": "32.9487557",
      "poi_longitude": "-80.1705363",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-873-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRy4OfGL_ogRN2AdSEEDJcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_431e54f732e1fa477b5cc3e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "The Flowertown Players",
      "poi_type": "Entertainment",
      "poi_address": "133 S Main St, Summerville, SC 29483, USA",
      "poi_short_description": "Community theater hosting productions by local actors, including shows for children.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-70f8-72ea-b2a5-333bbed32be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-70f8-72ea-b2a5-333bbed32be2",
        "storage_key": "property/6767906449167486/019e17c1-70f8-72ea-b2a5-333bbed32be2.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.flowertownplayers.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13934922031093686074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flowertown-players",
      "poi_latitude": "33.019135",
      "poi_longitude": "-80.17527799999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-875-9251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Tp0j2-L_ogROp8axMHJYsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_d7e871bfa065957d06ba498a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Public Works Art Center",
      "poi_type": "Entertainment",
      "poi_address": "135 W Richardson Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Cultural hub featuring exhibitions, classes, studio spaces, and a gift shop, plus summer camps.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-27a6-76d8-aa1d-65b646a81e4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-27a6-76d8-aa1d-65b646a81e4f",
        "storage_key": "property/6767906449167486/019e8434-27a6-76d8-aa1d-65b646a81e4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.publicworksartcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17863156384356378103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "public-works-art-center",
      "poi_latitude": "33.0198615",
      "poi_longitude": "-80.1770878",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-900-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ90Hx5aL_ogR9yXQqBau5vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_244153818411c8dbe620848e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Timrod Library",
      "poi_type": "Entertainment",
      "poi_address": "217 Central Ave, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-26fa-72f9-9450-bfe2e87f9d52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-26fa-72f9-9450-bfe2e87f9d52",
        "storage_key": "property/6767906449167486/019e8434-26fa-72f9-9450-bfe2e87f9d52.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://thetimrodlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=32285754143936210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "timrod-library",
      "poi_latitude": "33.0177616",
      "poi_longitude": "-80.17969939999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-871-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d5-7017-9a2d-a1d89a66620c",
        "storage_key": "property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0V23GSL_ogR0g4O67izcgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_15c693852d8cab68dc772352",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Montreux Bar & Grill",
      "poi_type": "Entertainment",
      "poi_address": "127 W Richardson Ave, Summerville, SC 29483, USA",
      "poi_short_description": "Relaxed hangout featuring a sizable beer list, burgers & other pub grub, plus a patio with a bar.",
      "poi_long_description": "Relaxed hangout featuring a sizable beer list, burgers & other pub grub, plus a patio with a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-78c2-77bb-9113-adb0ff4b23aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-78c2-77bb-9113-adb0ff4b23aa",
        "storage_key": "property/6767906449167486/019e17c1-78c2-77bb-9113-adb0ff4b23aa.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://montreuxbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15777595227584798198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montreux-bar--grill",
      "poi_latitude": "33.01974440000001",
      "poi_longitude": "-80.17673889999999",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-695-8125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aecf-70b4-904f-8cf2b297e8ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aecf-70b4-904f-8cf2b297e8ab",
        "storage_key": "property/6767906449167486/019e17c1-aecf-70b4-904f-8cf2b297e8ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTKPgWWL_ogR9h0XJkRH9do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_eb4d688e79650f1295967867",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Frothy Beard Off World Brewery and Taproom",
      "poi_type": "Entertainment",
      "poi_address": "117 S Main St, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-2ba7-7379-b263-b885b8034197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-2ba7-7379-b263-b885b8034197",
        "storage_key": "property/6767906449167486/019e8434-2ba7-7379-b263-b885b8034197.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://frothybeard.com/frothybeardoffworldbreweryandtaproom-eq5tjt?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12955482992525725813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frothy-beard-off-world-brewery-and-taproom",
      "poi_latitude": "33.0195693",
      "poi_longitude": "-80.175148",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 854-200-7419",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WsiSnuL_ogRdVAc_yMfy7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_c007a607f7e46aeafae4a48d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Brown Family Park",
      "poi_type": "Entertainment",
      "poi_address": "3000 Front St, Summerville, SC 29486, USA",
      "poi_short_description": "Park featuring an open field, a walking trail, and a playground with tire hammock swings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-28f0-7226-a0df-b95ad86e61e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-28f0-7226-a0df-b95ad86e61e7",
        "storage_key": "property/6767906449167486/019e8434-28f0-7226-a0df-b95ad86e61e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/facilities/facility/details/Brown-Family-Park-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=11928909217861347234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brown-family-park",
      "poi_latitude": "33.0429895",
      "poi_longitude": "-80.14383699999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-510-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQg3adCL_ogRoieCSLv_i6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_97346d3c2046d72ef5a55f19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "HCA Healthcare Summerville Hospital, A part of Trident Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "295 Midland Pkwy, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-90e3-7257-986d-aff8dbc161db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-90e3-7257-986d-aff8dbc161db",
        "storage_key": "property/6767906449167486/019e17c1-90e3-7257-986d-aff8dbc161db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/summerville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709934292123430214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-summerville-hospital-a-part-of-trident-hospital",
      "poi_latitude": "32.9657337",
      "poi_longitude": "-80.1575356",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 843-970-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d8-7479-bd2c-ca6b38653145",
        "storage_key": "property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzy_JxduL_ogRRq1yzUgMXUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_d6c8a9effd72c7f5d701f062",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "MEDcare Urgent Care - Summerville",
      "poi_type": "Health and Wellness",
      "poi_address": "1675 N Main St, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-28d6-713d-816c-30917dfc0291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-28d6-713d-816c-30917dfc0291",
        "storage_key": "property/6767906449167486/019e8434-28d6-713d-816c-30917dfc0291.webp",
        "width": 971,
        "height": 854
      },
      "poi_business_url": "https://www.medcareurgentcare.com/location/medcare-summerville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2974656415898178883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medcare-urgent-care---summerville",
      "poi_latitude": "33.0404662",
      "poi_longitude": "-80.1353855",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-285-2169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzxgbtGK_ogRQ5Vy9j8aSCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_aa4ea0e6f52d1b8b98e4d412",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "MUSC Health Primary Care - Carnes Crossroads",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 1st Ave, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-28e9-719f-9d8c-d512616a40f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-28e9-719f-9d8c-d512616a40f3",
        "storage_key": "property/6767906449167486/019e8434-28e9-719f-9d8c-d512616a40f3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.getcare.muschealth.org/locations/sc/summerville/musc-health-primary-care-carnes-crossroadsdep-90203001?y_source=1_MTI2NTc3MTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13147086913922236401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musc-health-primary-care---carnes-crossroads",
      "poi_latitude": "33.0549798",
      "poi_longitude": "-80.10094509999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-876-7930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXgoeFf1_ogR8X-FV-TVc7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_b0af74d6bdba774c6488576d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Publix Pharmacy at The Market Place at Carnes Crossroads",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N Main St a, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-fbe0-765e-a8f4-70c534d1dbd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-fbe0-765e-a8f4-70c534d1dbd8",
        "storage_key": "property/6767906449167486/019e7441-fbe0-765e-a8f4-70c534d1dbd8.webp",
        "width": 600,
        "height": 600
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=1909887121842969781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-the-market-place-at-carnes-crossroads",
      "poi_latitude": "33.0616512",
      "poi_longitude": "-80.0962393",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 843-879-5077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aee8-73be-9e88-d9af108edc6c",
        "storage_key": "property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzci0r2Zf_ogRtRyL4jdIgRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_f50bf84ae8a9384aedcd43ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Harris Teeter Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1269 Nexton Pkwy, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-8595-775b-9e1f-7e749807d5d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-8595-775b-9e1f-7e749807d5d1",
        "storage_key": "property/6767906449167486/019e17c1-8595-775b-9e1f-7e749807d5d1.webp",
        "width": 1044,
        "height": 587
      },
      "poi_business_url": "https://www.harristeeter.com/rx/pharmacy/details/097/00368?cid=loc_09700368P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16233256291855528468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter-pharmacy",
      "poi_latitude": "33.0589214",
      "poi_longitude": "-80.1515009",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-974-9474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aee8-73be-9e88-d9af108edc6c",
        "storage_key": "property/6767906449167486/019e17c1-aee8-73be-9e88-d9af108edc6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2-vHAD1_ogRFHLsB5ccSOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c40f10e8faeabc3bb77ee7a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1341 College Park Rd, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-885a-703e-87c2-829f722cd68e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-885a-703e-87c2-829f722cd68e",
        "storage_key": "property/6767906449167486/019e17c1-885a-703e-87c2-829f722cd68e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/summerville-college-park-sc?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7878199314101852113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.0447652",
      "poi_longitude": "-80.107168",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 854-231-8030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2UnZ4SL_ogR0VfEIon8VG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_b6947cf229270ae364a5692d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 N Main St, Summerville, SC 29483, USA",
      "poi_short_description": "Energetic fitness studio specializing in heart rate zone-based training and full-body workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-8d79-721d-a9da-6d7dff49ed4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-8d79-721d-a9da-6d7dff49ed4a",
        "storage_key": "property/6767906449167486/019e17c1-8d79-721d-a9da-6d7dff49ed4a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/summerville-south-carolina-0296?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=14482304825963688779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.0320441",
      "poi_longitude": "-80.16266379999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 843-970-2144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh-2LLj-L_ogRS7N9OIJ7-8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7043e6e9b0fc6ebcd23e0186",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Three Keys Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "503 Front St, Summerville, SC 29486, USA",
      "poi_short_description": "Studio offering yoga for all levels, as well as barre, heated and HIIT-style classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-2fb2-7058-ba47-791f36411626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-2fb2-7058-ba47-791f36411626",
        "storage_key": "property/6767906449167486/019e8434-2fb2-7058-ba47-791f36411626.webp",
        "width": 415,
        "height": 623
      },
      "poi_business_url": "https://www.threekeysyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16535775833074541076&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-keys-yoga",
      "poi_latitude": "33.0412025",
      "poi_longitude": "-80.1422042",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-376-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aeca-735d-8a1d-dbc465dc20d9",
        "storage_key": "property/6767906449167486/019e17c1-aeca-735d-8a1d-dbc465dc20d9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2_4fo7iL_ogRFKLlh4LgeuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_337b8ccb53cc60a64dbe35c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "CORA Physical Therapy Carnes Crossroads",
      "poi_type": "Health and Wellness",
      "poi_address": "515 Carnes Crossing Blvd Suite B, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-2ff5-70d5-95b1-7e8cc4bbca6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-2ff5-70d5-95b1-7e8cc4bbca6f",
        "storage_key": "property/6767906449167486/019e8434-2ff5-70d5-95b1-7e8cc4bbca6f.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://www.coraphysicaltherapy.com/location/summerville-south-carolina/?utm_source=google_business_profile&utm_medium=organic&utm_campaign=local_listings&utm_content=corahealth22",
      "poi_directions_map_url": "https://maps.google.com/?cid=2818227360439830142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cora-physical-therapy-carnes-crossroads",
      "poi_latitude": "33.0569193",
      "poi_longitude": "-80.1010316",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-507-8190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTkphLD1_ogRfoZNS9paHCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_ef61096cb98dc49c03595e97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Novant Health Urgent Care – Summerville (Formerly Doctors Care)",
      "poi_type": "Health and Wellness",
      "poi_address": "410 N Main St, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7441-f940-742e-9023-be952b9662af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7441-f940-742e-9023-be952b9662af",
        "storage_key": "property/6767906449167486/019e7441-f940-742e-9023-be952b9662af.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "https://www.novanthealth.org/locations/?query=novant+health+urgent+care+-+summerville&filter=name&zipcode=29483",
      "poi_directions_map_url": "https://maps.google.com/?cid=12485027198566916185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-urgent-care--summerville-formerly-doctors-care",
      "poi_latitude": "33.0247411",
      "poi_longitude": "-80.1721055",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 843-871-3277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY77lCmmL_ogRWeCrrRa6Q60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_31ffa0f9c79def8fda965991",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Dog Park @ Carnes Crossroads",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Parish Farms Dr, Summerville, SC 29486, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-891f-763d-a5cd-18caade5a185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-891f-763d-a5cd-18caade5a185",
        "storage_key": "property/6767906449167486/019e17c1-891f-763d-a5cd-18caade5a185.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1288127554965718060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dog-park--carnes-crossroads",
      "poi_latitude": "33.0540454",
      "poi_longitude": "-80.1050356",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 843-568-8045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ0PwlD1_ogRLMQfuy9Z4BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_0e177407b02b933a7334cc32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Pine Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "303 Chandler Creek Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-8b1f-7689-b473-2876cf0fff93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-8b1f-7689-b473-2876cf0fff93",
        "storage_key": "property/6767906449167486/019e17c1-8b1f-7689-b473-2876cf0fff93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/pine-trace-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2357599917483286512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-trace-park",
      "poi_latitude": "32.9821335",
      "poi_longitude": "-80.1572965",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 843-563-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZyHWceL_ogR8N8URKLgtyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bfbfaeb6c1695690b2e7f7d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Ashley River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Renken Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Relaxed riverside park featuring playgrounds, walking trails, dog parks and zip lines.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-9ac6-76da-80d5-157d84ffce50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-9ac6-76da-80d5-157d84ffce50",
        "storage_key": "property/6767906449167486/019e17c1-9ac6-76da-80d5-157d84ffce50.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/parks-master-plan/ashley-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8523128911980528156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ashley-river-park",
      "poi_latitude": "32.9596824",
      "poi_longitude": "-80.2003158",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-806-2426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97nbMiaP_ogRHAJ2hZY8SHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b44417d4238c3b13c46bcd4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Colonial Dorchester State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 State Park Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_long_description": "Colonial-era settlement with many original buildings & ruins, archaeological digs & guided tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-7979-76af-8b60-55f6e75f9da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-7979-76af-8b60-55f6e75f9da7",
        "storage_key": "property/6767906449167486/019e17c1-7979-76af-8b60-55f6e75f9da7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.southcarolinaparks.com/colonialdorchester",
      "poi_directions_map_url": "https://maps.google.com/?cid=13989591396413956151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-dorchester-state-historic-site",
      "poi_latitude": "32.9487557",
      "poi_longitude": "-80.1705363",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 12 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 843-873-1740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRy4OfGL_ogRN2AdSEEDJcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_0103aa3ed39ea5b643e3113c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Sawmill Branch Trail - E. Richardson Ave. Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Summerville, SC 29485, USA",
      "poi_short_description": "Paved pathway for walking and biking, plus a stream and views of ducks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-34ad-72ae-9e4e-62eb62a1e73b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-34ad-72ae-9e4e-62eb62a1e73b",
        "storage_key": "property/6767906449167486/019e8434-34ad-72ae-9e4e-62eb62a1e73b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9671525398587093533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawmill-branch-trail---e-richardson-ave-trailhead",
      "poi_latitude": "33.0152016",
      "poi_longitude": "-80.1698686",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH5bkFnKL_ogRHbLzqhspOIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_a2e2449855a3bcf66dc8b504",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Azalea Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 W 5th S St, Summerville, SC 29483, USA",
      "poi_short_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_long_description": "Scenic park with landscaped flower beds, ponds, sculptures, winding walking trails & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-18cb-746b-881c-26363eeb900a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17bf-18cb-746b-881c-26363eeb900a",
        "storage_key": "property/6767906449167486/019e17bf-18cb-746b-881c-26363eeb900a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/196/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16921181544976970789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azalea-park",
      "poi_latitude": "33.0143515",
      "poi_longitude": "-80.1774669",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fBkAnuL_ogRJXQ_gPYc1Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c457f72c514a05302c2d4857",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Gahagan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "184 W Boundary St, Summerville, SC 29485, USA",
      "poi_short_description": "Family-friendly park with baseball & football fields, plus a castle-like playground & picnic tables.",
      "poi_long_description": "Family-friendly park with baseball & football fields, plus a castle-like playground & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-1160-763f-a9ce-0a297af9f222.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17bf-1160-763f-a9ce-0a297af9f222",
        "storage_key": "property/6767906449167486/019e17bf-1160-763f-a9ce-0a297af9f222.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/519/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=6232569376996974259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gahagan-park",
      "poi_latitude": "33.00887",
      "poi_longitude": "-80.1662731",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-510-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcFLOQuL_ogRs97hqdOIflY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f48fcabf510cdc820de00263",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Rosebrock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "507 Beech Hill Rd, Summerville, SC 29485, USA",
      "poi_short_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_long_description": "Natural setting for riverside hikes through forest & wetlands, plus a picnic shelter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-8c40-74c7-b360-9952ca7f706d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-8c40-74c7-b360-9952ca7f706d",
        "storage_key": "property/6767906449167486/019e17c1-8c40-74c7-b360-9952ca7f706d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dorchestercountysc.gov/services/parks-recreation/rosebrock-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16520332637351917944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosebrock-park",
      "poi_latitude": "32.9489457",
      "poi_longitude": "-80.2059668",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 843-832-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL5ApnaeO_ogReDmnVAEDROU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_bda38e1acd5e445ffb43a48a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Wassamassaw Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "651 Wassamassaw Rd, Summerville, SC 29483, USA",
      "poi_short_description": "Venue offering a playground & picnic areas as well as basketball courts, a walking path & dog park.",
      "poi_long_description": "Venue offering a playground & picnic areas as well as basketball courts, a walking path & dog park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-946e-76da-b339-446f00dd0814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-946e-76da-b339-446f00dd0814",
        "storage_key": "property/6767906449167486/019e17c1-946e-76da-b339-446f00dd0814.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.summervillesc.gov/facilities/facility/details/Wassamassaw-Community-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=16804253610973531989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wassamassaw-community-park",
      "poi_latitude": "33.0343987",
      "poi_longitude": "-80.1826865",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-851-5211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03jXxVuL_ogRVQ-nXaCzNOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0fc35d9266a1d87d970af726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Wannamaker North Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "455 Westview Blvd, Goose Creek, SC 29445, USA",
      "poi_short_description": "Rugged country park offering 15 mi. of trails for biking, jogging & hiking.",
      "poi_long_description": "Rugged country park offering 15 mi. of trails for biking, jogging & hiking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-34fb-727a-8296-e8fb7589fdf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-34fb-727a-8296-e8fb7589fdf0",
        "storage_key": "property/6767906449167486/019e8434-34fb-727a-8296-e8fb7589fdf0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ccprc.com/listing/wannamaker-north-trail/50/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2254870177367659750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wannamaker-north-trail",
      "poi_latitude": "32.9986734",
      "poi_longitude": "-80.0590011",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 843-795-4386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c7-71ac-a9d2-847385ea1796",
        "storage_key": "property/6767906449167486/019e17bf-21c7-71ac-a9d2-847385ea1796.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcpSVU1g_ogR5hSfwHroSh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b18d918696964ffdda720e7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Dorchester Village Shopping Center Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "South Carolina 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-94dd-7691-b057-50fbd1604fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-94dd-7691-b057-50fbd1604fb4",
        "storage_key": "property/6767906449167486/019e17c1-94dd-7691-b057-50fbd1604fb4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2617586219132431381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorchester-village-shopping-center-park--ride",
      "poi_latitude": "32.9532117",
      "poi_longitude": "-80.1692379",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6o4OFyJ_ogRFaxYOMyIUyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_d7d0d72f4e924865bf920be5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Crossroads Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "2885 W 5th N St, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7786375334096290911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-plaza",
      "poi_latitude": "33.0551606",
      "poi_longitude": "-80.23718439999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aefe-77aa-8ba6-97ed51bea648",
        "storage_key": "property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoSmwmfHz_ogRX0SsxBzDDmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_4b6ab094805eb9a50a9b2741",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "North Charleston Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Melnick Dr, North Charleston, SC 29406, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-9b7f-7150-9b77-e773df129e43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-9b7f-7150-9b77-e773df129e43",
        "storage_key": "property/6767906449167486/019e17c1-9b7f-7150-9b77-e773df129e43.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://ridecarta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7348761912706324910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-park--ride",
      "poi_latitude": "32.9610865",
      "poi_longitude": "-80.0470412",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-af0d-7725-b543-687c5d1021e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-af0d-7725-b543-687c5d1021e9",
        "storage_key": "property/6767906449167486/019e17c1-af0d-7725-b543-687c5d1021e9.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbJnFGRh_ogRrtnHMQYM_GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_b01d9aa585b986869490d451",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "North Charleston Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4565 Gaynor Ave, North Charleston, SC 29405, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7442-0ad3-74c8-bc2e-adc20c4edf2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7442-0ad3-74c8-bc2e-adc20c4edf2c",
        "storage_key": "property/6767906449167486/019e7442-0ad3-74c8-bc2e-adc20c4edf2c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ridecarta.com/news-announcements/intermodal-facility-project/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18388241308575805294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-charleston-transit-center",
      "poi_latitude": "32.8755257",
      "poi_longitude": "-79.9979853",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 52 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 843-724-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-Lvgxdl_ogRbi_TiQsoMP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_dbc4605b098940a92f32b202",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Charleston International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5500 International Blvd, North Charleston, SC 29418, USA",
      "poi_short_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_long_description": "Long-standing regional airport serving the Southeast & featuring various rental car options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-9ac7-7591-9692-4dd384431c61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-9ac7-7591-9692-4dd384431c61",
        "storage_key": "property/6767906449167486/019e17c1-9ac7-7591-9692-4dd384431c61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.iflychs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2038942955165646559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleston-international-airport",
      "poi_latitude": "32.8916648",
      "poi_longitude": "-80.0395233",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 36 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 843-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-af10-7162-afd1-0e603b118fdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-af10-7162-afd1-0e603b118fdd",
        "storage_key": "property/6767906449167486/019e17c1-af10-7162-afd1-0e603b118fdd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyrqSw9j_ogR3_7un9DHSxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_a8dc7ce8ceff7dd5d8238f6f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Azalea Square",
      "poi_type": "Transportation & Transit",
      "poi_address": "214 Azalea Square Blvd, Summerville, SC 29483, USA",
      "poi_short_description": "Pedestrian-friendly mall featuring a variety of shops, dining venues, and convenient parking (sometimes crowded, especially at peak times).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-36fd-719d-a466-7732c3d091fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-36fd-719d-a466-7732c3d091fa",
        "storage_key": "property/6767906449167486/019e8434-36fd-719d-a466-7732c3d091fa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shopazaleasquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=97002748202442636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "azalea-square",
      "poi_latitude": "33.0398565",
      "poi_longitude": "-80.15743119999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 877-206-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17c1-aefe-77aa-8ba6-97ed51bea648",
        "storage_key": "property/6767906449167486/019e17c1-aefe-77aa-8ba6-97ed51bea648.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG40jemOL_ogRjN_XTHyfWAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_2e0fe4896c546e109b3fdfbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "KION North America Plant 1",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2450 W 5th N St, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-35bb-755e-a88c-76ac41720ab3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-35bb-755e-a88c-76ac41720ab3",
        "storage_key": "property/6767906449167486/019e8434-35bb-755e-a88c-76ac41720ab3.webp",
        "width": 1280,
        "height": 681
      },
      "poi_business_url": "https://www.kion-na.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10934366258904715046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kion-north-america-plant-1",
      "poi_latitude": "33.0462199",
      "poi_longitude": "-80.2195505",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-875-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6aaR86M_ogRJk8IAi6svpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_e1e43f53444358d13e39d0bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Scout Boats",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2531 US-78, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-3949-7059-95bf-45c3b86da28b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-3949-7059-95bf-45c3b86da28b",
        "storage_key": "property/6767906449167486/019e8434-3949-7059-95bf-45c3b86da28b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://scoutboats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8501639130093929969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scout-boats",
      "poi_latitude": "33.0404287",
      "poi_longitude": "-80.2075557",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 843-821-0068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAzqcQriM_ogR8UXPxb7j-3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_3db6e9565309e9adc4d39e3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Robert Bosch LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1124 Newton Way, Summerville, SC 29483, USA",
      "poi_short_description": "Warehouse whose reviews say the staff is fast and friendly.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e8434-363a-710d-a28d-15a0e5618d90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e8434-363a-710d-a28d-15a0e5618d90",
        "storage_key": "property/6767906449167486/019e8434-363a-710d-a28d-15a0e5618d90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bosch.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=836510833247017111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-bosch-llc",
      "poi_latitude": "33.0653808",
      "poi_longitude": "-80.1965792",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 843-879-5223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZwMiIDz_ogRl1h0uivimws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_c74ab69a300477c0ba86150e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "HCA Healthcare Summerville Hospital, A part of Trident Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "295 Midland Pkwy, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-90e3-7257-986d-aff8dbc161db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-90e3-7257-986d-aff8dbc161db",
        "storage_key": "property/6767906449167486/019e17c1-90e3-7257-986d-aff8dbc161db.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tridenthealthsystem.com/locations/summerville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4709934292123430214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-healthcare-summerville-hospital-a-part-of-trident-hospital",
      "poi_latitude": "32.9657337",
      "poi_longitude": "-80.1575356",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 843-970-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d8-7479-bd2c-ca6b38653145",
        "storage_key": "property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzy_JxduL_ogRRq1yzUgMXUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_d7a109b95d83de53d14c0215",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "MUSC Health Nexton Medical Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5500 Front St Suite 320 and Suite 440, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7442-0d83-7099-8c8d-bfeb60ff71ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7442-0d83-7099-8c8d-bfeb60ff71ec",
        "storage_key": "property/6767906449167486/019e7442-0d83-7099-8c8d-bfeb60ff71ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.getcare.muschealth.org/locations/sc/summerville/musc-health-nexton-medical-parkdep-fac291?y_source=1_MTc3Mzc2NTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472779134036253399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musc-health-nexton-medical-park",
      "poi_latitude": "33.0439283",
      "poi_longitude": "-80.146693",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 843-792-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7WYRj02L_ogR15panyLJVpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b73c7948a3a84b8553b06e20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Summerville Town Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1701 Old Trolley Rd, Summerville, SC 29485, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7442-12f3-757c-8b65-ea6b9405a725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7442-12f3-757c-8b65-ea6b9405a725",
        "storage_key": "property/6767906449167486/019e7442-12f3-757c-8b65-ea6b9405a725.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.summervillesc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6693457960589894912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summerville-town-office",
      "poi_latitude": "32.9599485",
      "poi_longitude": "-80.16435",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 843-851-4113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d5-7017-9a2d-a1d89a66620c",
        "storage_key": "property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdyxHGCJ_ogRAKX4O43w41w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_853be4a6a3d7759fbaa1ee7b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Dorchester County Facilities",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 N Main St #3, Summerville, SC 29483, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.dorchestercountysc.gov/government/facilities-maintenance",
      "poi_directions_map_url": "https://maps.google.com/?cid=9206523271643961006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorchester-county-facilities",
      "poi_latitude": "33.0261775",
      "poi_longitude": "-80.1717753",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 843-832-0012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d5-7017-9a2d-a1d89a66620c",
        "storage_key": "property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxWEg2mL_ogRrpa0JiMkxH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_5f9715d172b8ddf461d8172d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Joint Base Charleston",
      "poi_type": "Major Employers & Offices",
      "poi_address": "102 E Hill Blvd, Joint Base Charleston, SC 29404, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e7442-0cc7-758d-9362-588c697f8604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e7442-0cc7-758d-9362-588c697f8604",
        "storage_key": "property/6767906449167486/019e7442-0cc7-758d-9362-588c697f8604.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.jbcharleston.jb.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483304259841560535&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-base-charleston",
      "poi_latitude": "32.8974054",
      "poi_longitude": "-80.05202539999999",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 843-963-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d5-7017-9a2d-a1d89a66620c",
        "storage_key": "property/6767906449167486/019e17bf-21d5-7017-9a2d-a1d89a66620c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z4rC-Vi_ogR1w_ag3jlNz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_9db817864d8112db7ab7a4d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "MUSC Health University Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "171 Ashley Ave, Charleston, SC 29425, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-a210-750c-a674-eebdb1b4a081.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-a210-750c-a674-eebdb1b4a081",
        "storage_key": "property/6767906449167486/019e17c1-a210-750c-a674-eebdb1b4a081.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.getcare.muschealth.org/locations/sc/charleston/musc-health-university-medical-centerdep-fac139?y_source=1_MTI2NTc3MDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12189662782097550663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musc-health-university-medical-center",
      "poi_latitude": "32.7849784",
      "poi_longitude": "-79.9472066",
      "poi_miles_from_property": "36.3 mi",
      "poi_walking_minutes": "13 hours 13 mins",
      "poi_biking_minutes": "2 hours 15 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 843-792-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21d8-7479-bd2c-ca6b38653145",
        "storage_key": "property/6767906449167486/019e17bf-21d8-7479-bd2c-ca6b38653145.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWT8sDh6_ogRR225erdhKqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_15fb6dce582e116d7d7b20d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "generator",
      "poi_name": "Boeing South Carolina Delivery Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 Airframe Dr, North Charleston, SC 29418, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-a3fb-731b-8551-7e742c685285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e17c1-a3fb-731b-8551-7e742c685285",
        "storage_key": "property/6767906449167486/019e17c1-a3fb-731b-8551-7e742c685285.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1818565927026470829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boeing-south-carolina-delivery-center",
      "poi_latitude": "32.8772636",
      "poi_longitude": "-80.027445",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 312-544-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e17bf-21c4-744a-83fe-1a35bfbfa952",
        "storage_key": "property/6767906449167486/019e17bf-21c4-744a-83fe-1a35bfbfa952.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVx4OUFj_ogRra8KURPYPBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f9780fd6-ec71-4ccf-b7ce-a41f53d24e3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d59467d6-dcee-490d-bf6d-73cfd4fbd7c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e9a7ed51-7bfd-4280-83c8-efe59d2fa692",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_2096e78f-6ca1-4be0-bcc3-67277ccfdccf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bd300715-24e4-4546-9edf-bab2a2b63d4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fcf15f2d-1cf9-4dcb-953e-3f231e404e3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4582bedb8f7b171b95e99f6f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "rating": "5",
      "name": "Tammy Dyson",
      "text": "I moved here in July 2025 and from the start I have had nothing but a Great experience.  Smooth move in process, and when I have had any issues maintenance and the office staff have been very helpful and willing to make accommodations when needed.  Office staff communicates very well and is always willing to help if something comes up.  The community overall is amazing, great amenities,  the gym is a full gym, the club house and pool are amazing and the bonus is that they even have a dog wash...I will add they are Military Friendly and very understanding in that aspect. I would recommend this Apartment Community to anyone looking for a nice quiet  place to call home.  They definitely make you feel like you are at home here.",
      "date": "2026-01-06",
      "title": "false"
    },
    {
      "id": "ec_c63a745362d6e38ded072071",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "rating": "5",
      "name": "Carter Productions",
      "text": "I’ve lived here since February of last year and I have nothing but good remarks in terms of my experience I’ve had while here. Staff is super friendly, maintenance requests are fulfilled promptly, relatively quiet area, and the best for last.. the free coffee in the leasing office 😍. No seriously though I remember them completely my rental application in a timely manner and helped with me all my questions I had for a first time renter. Would definitely recommend living here. (I took those photos outside on a sunny day in my free time)",
      "date": "2024-03-01",
      "title": "false"
    },
    {
      "id": "ec_d16993271c92455fe80eb483",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "rating": "5",
      "name": "Ashley Reddick",
      "text": "It was a wonderful 5 years of being a resident at Azure Carnes and the most recent office staff of ladies were truly the best and most helpful to us. We truly enjoyed our time at Azure! We will miss the community!",
      "date": "2026-05-13",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_edf7756a-3503-4b04-af35-f99e08ef1d95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019e17c1-a1fd-767d-94f0-d5944a8ed73e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e17c1-a1fd-767d-94f0-d5944a8ed73e",
        "storage_key": "property/6767906449167486/019e17c1-a1fd-767d-94f0-d5944a8ed73e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,550 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=apvvTqukHf8"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e744c-e3de-7383-be13-f74f22bde1a7",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "american-landmark-azure-carnes-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486"
    },
    {
      "lead_collector_id": "019f8fa0-5822-744a-82b0-c3c65f5f1c86",
      "lead_source": "LANDING_PAGE",
      "name": "Azure Carnes Crossroads Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "lagoon-style-pool-apartments-summerville-sc-550",
      "search_query": "lagoon style pool apartments Summerville SC",
      "category": "Amenity",
      "h1_title": "Lagoon Style Pool Apartments in Summerville",
      "h2_subtitle": "Discover lagoon style pool apartments in Summerville, SC. Enjoy luxury living at Azure Carnes Crossroads with top-notch amenities.",
      "page_copy": "Dive into luxury at Azure Carnes Crossroads, featuring stunning lagoon style pool apartments in Summerville, SC. Our community offers a refreshing escape with a lagoon-style pool that's just one of many upscale amenities available. Relax and unwind in the serene surroundings, perfect for leisurely afternoons in the heart of charming Summerville.\n\nAt Azure Carnes Crossroads, you'll not only enjoy a picturesque pool but also access to a well-equipped fitness center, pavilion lounge, and more. Whether you're in search of one, two, or three-bedroom plans, our modern designs ensure comfort and style. Make the most of apartment living with select units offering soaking tubs and corridor-attached garages. Discover your sanctuary today and schedule a tour!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lagoon Style Pool Apartments Summerville, SC",
      "seo_description": "Discover lagoon style pool apartments in Summerville, SC at Azure Carnes Crossroads. Dive into luxury living with our upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-fitness-center-berkeley-county-263",
      "search_query": "luxury apartments with fitness center Berkeley County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Explore luxury apartments with a fitness center in Berkeley County. Azure Carnes Crossroads offers modern living and exceptional amenities.",
      "page_copy": "Discover luxurious living at Azure Carnes Crossroads, a premier choice for those seeking apartments with a fitness center in Berkeley County. Our state-of-the-art fitness facility allows residents to stay active and maintain their wellness routines without ever leaving the comfort of their home environment. Complemented by a range of upscale amenities, Azure Carnes Crossroads delivers an unparalleled living experience.\n\nNestled in the heart of Summerville, SC, our community offers more than just fitness facilities. Imagine relaxing by the lagoon-style pool or hosting friends in the pavilion lounge. With one, two, and three-bedroom floor plans available, each designed with modern elegance, you'll find the perfect space to call home. Schedule a visit today to experience the exceptional lifestyle awaiting you at Azure Carnes Crossroads.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center in Berkeley County",
      "seo_description": "Experience luxury apartments with a fitness center in Berkeley County at Azure Carnes Crossroads. Modern amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-goose-creek-59",
      "search_query": "apartments with air conditioning Goose Creek",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Nearby",
      "h2_subtitle": "Find comfortable apartments with air conditioning near Goose Creek. Azure Carnes Crossroads offers modern comfort and convenient amenities.",
      "page_copy": "Stay cool and comfortable at Azure Carnes Crossroads, where you'll find apartments with air conditioning near Goose Creek. Our contemporary floor plans offer one, two, and three-bedroom options, each designed to provide optimal comfort and style. The refreshing air conditioning ensures you can enjoy your home in comfort, even during the warmest South Carolina days.\n\nBeyond providing climate-controlled living spaces, Azure Carnes Crossroads features a host of exceptional amenities, including a lagoon-style pool and a fitness center perfect for unwinding or staying active. Located in the inviting community of Summerville, our apartments are just a stone's throw away from Goose Creek, offering residents the serenity of suburban life with easy access to nearby amenities. Contact us today to explore the possibilities of living in comfort at Azure Carnes Crossroads.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning Near Goose Creek",
      "seo_description": "Explore apartments with air conditioning near Goose Creek at Azure Carnes Crossroads. Comfort and modern amenities await!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-with-dog-spa-summerville-940",
      "search_query": "pet friendly apartments with dog spa Summerville",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Spa",
      "h2_subtitle": "Explore pet friendly apartments with a dog spa in Summerville. Azure Carnes Crossroads offers amenities for you and your furry friend.",
      "page_copy": "Welcome to Azure Carnes Crossroads, where you and your furry friends will love our pet friendly apartments with a dog spa in Summerville. Our community is designed to cater not just to you but also your pets, featuring a Paw Spa that ensures they are pampered and well taken care of. This unique amenity sets us apart as an ideal home for pet owners looking for comfort and convenience.\n\nLocated in charming Summerville, SC, Azure Carnes Crossroads offers more than just a welcoming environment for pets. Our modern one, two, and three-bedroom floor plans include features that make life easy and enjoyable. Enjoy access to exceptional amenities like a lagoon-style pool and a modern fitness center, enhancing your lifestyle. Contact us today and discover how our pet-friendly community can be the perfect fit for you and your furry companion.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Spa in Summerville",
      "seo_description": "Find pet friendly apartments with a dog spa in Summerville at Azure Carnes Crossroads. Enjoy luxurious amenities for you and your pet!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-near-29486-485",
      "search_query": "apartments with in unit laundry near 29486",
      "category": "Amenity",
      "h1_title": "Convenient Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry near 29486 at Azure Carnes Crossroads. Enjoy ultimate convenience in modern living spaces.",
      "page_copy": "Experience the ultimate convenience at Azure Carnes Crossroads, offering apartments with in-unit laundry near 29486. Our modern one, two, and three-bedroom floor plans include personal laundry facilities, streamlining daily routines and enhancing your living experience. Say goodbye to the hassle of shared laundry rooms and enjoy the ease of doing laundry from the comfort of your own home.\n\nLocated in vibrant Summerville, SC, Azure Carnes Crossroads delivers more than just in-unit conveniences. Our residents enjoy access to premium amenities such as a lagoon-style pool, pavilion lounge, and state-of-the-art fitness center. These thoughtfully designed spaces cater to a modern lifestyle, ensuring you have everything you need within reach. Schedule a tour today to see how Azure Carnes Crossroads meets all your living needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Near 29486",
      "seo_description": "Find convenient apartments with in-unit laundry near 29486 at Azure Carnes Crossroads. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-summerville-sc-73",
      "search_query": "1 bedroom apartments Summerville SC",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Summerville SC",
      "h2_subtitle": "Explore stylish 1 bedroom apartments in Summerville, SC. Azure Carnes Crossroads offers modern living with premium amenities.",
      "page_copy": "Discover the perfect one-bedroom apartment at Azure Carnes Crossroads located in charming Summerville, SC. Our meticulously designed one-bedroom units offer a blend of comfort and style, making them ideal for individuals or couples looking for a cozy yet luxurious living space. Each apartment boasts modern finishes and features such as spacious closets and optional soaking tubs, enhancing your everyday living experience.\n\nAzure Carnes Crossroads provides a range of upscale amenities that elevate your lifestyle. Enjoy relaxing by our lagoon-style pool, staying active in the fitness center, or unwinding in the pavilion lounge. Situated in a prime location, you'll have easy access to local attractions while relishing the tranquility of Summerville's suburban setting. Schedule a visit today to find your ideal one-bedroom apartment at Azure Carnes Crossroads.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Summerville, SC",
      "seo_description": "Browse stylish 1 bedroom apartments in Summerville, SC at Azure Carnes Crossroads. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-berkeley-county-228",
      "search_query": "2 bedroom apartments Berkeley County",
      "category": "Floorplan",
      "h1_title": "Spacious 2 Bedroom Apartments in Berkeley County",
      "h2_subtitle": "Find ideal 2 bedroom apartments in Berkeley County at Azure Carnes Crossroads, offering modern layouts and top-notch amenities.",
      "page_copy": "Welcome to Azure Carnes Crossroads, offering spacious 2 bedroom apartments in Berkeley County. Designed for comfort and style, our two-bedroom units provide generous living spaces, modern kitchens, and ample storage, perfect for a small family or roommates. Each apartment is thoughtfully crafted to ensure you feel at home from day one.\n\nLocated in the scenic setting of Summerville, Azure Carnes Crossroads combines suburban tranquility with sophisticated community features. Indulge in our lagoon-style pool, stay fit at the fully-equipped fitness center, or socialize at the pavilion lounge. Our community is nestled in Berkeley County, giving you easy access to both natural beauty and urban conveniences. Discover the perfect two-bedroom apartment tailored to your lifestyle by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Berkeley County, SC",
      "seo_description": "Discover spacious 2 bedroom apartments in Berkeley County at Azure Carnes Crossroads. Enjoy modern layouts and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-near-goose-creek-955",
      "search_query": "3 bedroom apartments near Goose Creek",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near Goose Creek",
      "h2_subtitle": "Explore 3 bedroom apartments near Goose Creek at Azure Carnes Crossroads. Enjoy spacious layouts and luxury finishes in a prime location.",
      "page_copy": "Discover the perfect home for larger households at Azure Carnes Crossroads, offering exquisite 3 bedroom apartments near Goose Creek. Our expansive floor plans are designed to provide ample space without sacrificing comfort, featuring modern kitchens, large living areas, and select units with corridor-attached garages. These thoughtfully designed spaces offer a perfect blend of functionality and style.\n\nLocated conveniently close to Goose Creek, Azure Carnes Crossroads is nestled in the vibrant community of Summerville. Enjoy access to luxury amenities like our lagoon-style pool, state-of-the-art fitness center, and the serene greenspaces that make relaxing at home a breeze. Experience the best of both worlds with suburban tranquility and easy access to urban conveniences. Schedule a tour today and envision life in our stunning three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near Goose Creek, SC",
      "seo_description": "Stylish 3 bedroom apartments near Goose Creek available at Azure Carnes Crossroads. Enjoy spacious living with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-close-to-cane-bay-elementary-school-974",
      "search_query": "apartments close to Cane Bay Elementary School Goose Creek",
      "category": "School",
      "h1_title": "Apartments Close to Cane Bay Elementary School",
      "h2_subtitle": "Find ideal apartments close to Cane Bay Elementary School in Goose Creek. Azure Carnes Crossroads offers convenient family living in Summerville.",
      "page_copy": "Azure Carnes Crossroads in Summerville features beautiful apartments close to Cane Bay Elementary School, perfect for families seeking convenience and quality education. Our community offers a selection of one to three-bedroom floor plans, each designed with both style and practicality in mind.\n\nLiving at Azure Carnes Crossroads means experiencing the best of suburban life while staying near Goose Creek's top educational establishments. Alongside proximity to Cane Bay Elementary School, residents enjoy access to premium amenities such as a pavilion lounge, a well-equipped fitness center, and spacious greenspaces, ensuring a perfect blend of leisure and functional living. Make our vibrant community your new home by scheduling a tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cane Bay Elementary School",
      "seo_description": "Discover family-friendly apartments near Cane Bay Elementary School in Goose Creek at Azure Carnes Crossroads, offering modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "summerville-apartments-near-cane-bay-middle-school-440",
      "search_query": "Summerville SC apartments near Cane Bay Middle School",
      "category": "School",
      "h1_title": "Summerville Apartments Near Cane Bay Middle School",
      "h2_subtitle": "Explore Summerville SC apartments near Cane Bay Middle School. Azure Carnes Crossroads offers family-friendly living close to education and amenities.",
      "page_copy": "Discover the perfect place for family living at Azure Carnes Crossroads, offering exceptional apartments near Cane Bay Middle School in Summerville, SC. Our stylish one, two, and three-bedroom floor plans provide the ideal setting for educational and leisurely pursuits alike, blending modern designs with comfortable living spaces.\n\nIdeally situated in Summerville, our community not only offers easy access to Cane Bay Middle School but also boasts a variety of upscale amenities such as a lagoon-style pool, a fitness center, and peaceful greenspaces. This perfect location ensures that families enjoy both convenience and tranquility. Experience the benefits of residing in a welcoming neighborhood with top-notch educational opportunities by visiting us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Summerville Apartments Near Cane Bay Middle School",
      "seo_description": "Find modern apartments near Cane Bay Middle School in Summerville, SC at Azure Carnes Crossroads, providing family-friendly amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-ridge-christian-academy-sc-574",
      "search_query": "apartments near Ridge Christian Academy SC",
      "category": "School",
      "h1_title": "Apartments Near Ridge Christian Academy SC",
      "h2_subtitle": "Discover comfortable apartments near Ridge Christian Academy SC. Azure Carnes Crossroads provides upscale amenities in a serene environment.",
      "page_copy": "At Azure Carnes Crossroads, you'll find the ideal place to call home, conveniently located near Ridge Christian Academy in Summerville, SC. Our beautiful one to three-bedroom apartments offer the perfect setting for families seeking quality education and modern living.\n\nSituated in Berkeley County, our community not only provides easy access to Ridge Christian Academy but also features a host of premium amenities. Relax by the lagoon-style pool, keep fit in the fully-equipped fitness center, or unwind in our serene greenspaces. Experience the perfect balance of convenience, comfort, and community at Azure Carnes Crossroads, and schedule a tour to discover your future home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ridge Christian Academy SC",
      "seo_description": "Find modern apartments near Ridge Christian Academy SC at Azure Carnes Crossroads, offering convenience and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-close-to-pinewood-preparatory-summerville-506",
      "search_query": "apartments close to Pinewood Preparatory School Summerville",
      "category": "School",
      "h1_title": "Apartments Close to Pinewood Preparatory School",
      "h2_subtitle": "Explore apartments close to Pinewood Preparatory School in Summerville. Azure Carnes Crossroads offers ideal family living and modern amenities.",
      "page_copy": "Azure Carnes Crossroads is the perfect choice for those seeking quality living near Pinewood Preparatory School in Summerville, SC. Our stylish one, two, and three-bedroom apartments provide the ultimate in comfort and convenience, making them an ideal option for families prioritizing education and lifestyle.\n\nLocated in the vibrant community of Summerville, our property offers more than just proximity to Pinewood Preparatory School. Residents can enjoy a range of amenities, including a lagoon-style pool, a fully-equipped fitness center, and relaxing greenspaces. These features, alongside its prime location, make Azure Carnes Crossroads an attractive home for those aiming to combine quality education with modern living. Visit us today to see why our community is the perfect place for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Pinewood Preparatory School",
      "seo_description": "Discover upscale living at Azure Carnes Crossroads, offering apartments near Pinewood Preparatory School in Summerville with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-hca-healthcare-summerville-hospital-491",
      "search_query": "apartments near HCA Healthcare Summerville Hospital Goose Creek",
      "category": "Hospital",
      "h1_title": "Apartments Near HCA Healthcare Summerville Hospital",
      "h2_subtitle": "Explore apartments near HCA Healthcare Summerville Hospital in Goose Creek. Azure Carnes Crossroads offers comfort and convenience in one package.",
      "page_copy": "Azure Carnes Crossroads offers the perfect blend of convenience and luxury for those seeking apartments near HCA Healthcare Summerville Hospital in Goose Creek. With easy access to healthcare facilities, our one, two, and three-bedroom apartments cater to medical professionals and those who value proximity to healthcare services.\n\nSet in the charming area of Summerville, SC, our community features upscale amenities designed for relaxation and convenience. Residents can enjoy a refreshing swim in our lagoon-style pool, work out in the modern fitness center, or simply relax in one of our tranquil greenspaces. With corridor-attached garages and a paw spa, Azure Carnes Crossroads ensures comfort and ease for you and your pets. Schedule a visit today to find out how our community can enhance your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near HCA Healthcare Summerville Hospital",
      "seo_description": "Discover Azure Carnes Crossroads, offering vibrant apartments near HCA Healthcare Summerville Hospital in Goose Creek with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-dog-park-carnes-crossroads-summerville-800",
      "search_query": "apartments near Dog Park at Carnes Crossroads Summerville",
      "category": "Park",
      "h1_title": "Apartments Near Dog Park at Carnes Crossroads",
      "h2_subtitle": "Find ideal apartments near the Dog Park at Carnes Crossroads. Azure Carnes Crossroads offers pet-friendly living in Summerville.",
      "page_copy": "Azure Carnes Crossroads is the perfect haven for both you and your furry friends, ideally located near the Dog Park at Carnes Crossroads in Summerville, SC. Our pet-friendly community is an excellent choice for pet lovers looking to provide their companions with the freedom they deserve.\n\nWith stylish one, two, and three-bedroom options, our community offers spacious apartments with high-quality finishes and exclusive amenities. Beyond the dog park, enjoy the lagoon-style pool, a modern fitness center, and relaxing greenspaces. Your pets will also appreciate the on-site paw spa, making grooming easy and convenient. Explore Azure Carnes Crossroads today, where pet-friendly living and comfort unite.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dog Park at Carnes Crossroads",
      "seo_description": "Discover pet-friendly living at Azure Carnes Crossroads, ideally located near the Dog Park at Carnes Crossroads in Summerville with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-close-to-pine-trace-park-goose-creek-160",
      "search_query": "apartments close to Pine Trace Park Goose Creek",
      "category": "Park",
      "h1_title": "Apartments Close to Pine Trace Park",
      "h2_subtitle": "Discover apartments close to Pine Trace Park in Goose Creek. Azure Carnes Crossroads offers a balanced lifestyle with modern amenities.",
      "page_copy": "Discover the charm of living near Pine Trace Park with Azure Carnes Crossroads, offering stylish apartments in proximity to this beautiful Goose Creek locale. With serene greenspaces and state-of-the-art recreational amenities, our community perfectly complements the outdoor allure of Pine Trace Park.\n\nChoose from our chic one, two, or three-bedroom floor plans, each featuring modern finishes. Enjoy community perks like a lagoon-style pool, a pavilion lounge, a well-equipped fitness center, and much more. At Azure Carnes Crossroads, you can relish peaceful park-side living while enjoying easy access to local amenities and recreation. Visit us today to explore how Azure Carnes Crossroads can enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Pine Trace Park",
      "seo_description": "Enjoy the proximity to Pine Trace Park with Azure Carnes Crossroads, offering stylish living and modern amenities in Goose Creek.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-ashley-river-park-berkeley-county-961",
      "search_query": "apartments near Ashley River Park Berkeley County",
      "category": "Park",
      "h1_title": "Apartments Near Ashley River Park",
      "h2_subtitle": "Explore apartments near Ashley River Park in Berkeley County. Experience exceptional living at Azure Carnes Crossroads in Summerville.",
      "page_copy": "Embrace the serene beauty of Ashley River Park with a home at Azure Carnes Crossroads, where nature and luxury living converge in Berkeley County. Our community offers immediate access to the park's natural charm, making it an ideal location for outdoor enthusiasts.\n\nChoose from one, two, or three-bedroom apartments, each designed with modern sophistication and comfort. Residents at Azure Carnes Crossroads enjoy fabulous amenities such as a lagoon-style pool, pavilion lounge, and tranquil greenspaces. The community also caters to pet owners with an on-site paw spa. Schedule a tour today and see how close-to-nature living at Azure Carnes Crossroads can elevate your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ashley River Park",
      "seo_description": "Find your dream home at Azure Carnes Crossroads, with stylish apartments near Ashley River Park in Berkeley County and fabulous amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-close-to-colonial-dorchester-shs-70",
      "search_query": "apartments close to Colonial Dorchester State Historic Site SC",
      "category": "Park",
      "h1_title": "Apartments Close to Colonial Dorchester",
      "h2_subtitle": "Live near the historic Colonial Dorchester State Historic Site in SC. Azure Carnes Crossroads offers a blend of comfort and historical charm.",
      "page_copy": "Azure Carnes Crossroads places you steps away from the rich history of the Colonial Dorchester State Historic Site in SC. Offering an immersive backdrop of history and culture, this location is perfect for those who appreciate heritage and modern living.\n\nOur one, two, and three-bedroom apartments are thoughtfully designed with upscale finishes and comprehensive amenities like a fitness center and a lagoon-style pool. Take full advantage of the nearby historic site for leisurely exploration, then relax in our pavilion lounge or enjoy the beautifully landscaped greenspaces back home. Visit us and see how Azure Carnes Crossroads seamlessly blends history with contemporary comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Colonial Dorchester Site",
      "seo_description": "Experience modern living at Azure Carnes Crossroads, near the Colonial Dorchester State Historic Site in SC, with spacious apartments and stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-close-to-gahagan-park-summerville-607",
      "search_query": "apartments close to Gahagan Park Summerville",
      "category": "Park",
      "h1_title": "Apartments Close to Gahagan Park",
      "h2_subtitle": "Discover comfortable apartments close to Gahagan Park in Summerville. Azure Carnes Crossroads offers a perfect fusion of modern living and park-side access.",
      "page_copy": "Azure Carnes Crossroads is perfectly positioned for those looking to enjoy life near Gahagan Park in Summerville. This prime location provides easy access to the park's recreational facilities, offering a refreshing blend of outdoor activities and contemporary apartment living.\n\nOur community boasts beautifully designed one, two, and three-bedroom apartments complemented by luxurious amenities such as a lagoon-style pool, pavilion lounge, and a state-of-the-art fitness center. Whether it’s a morning jog in Gahagan Park or an evening relaxing in our serene greenspaces, Azure Carnes Crossroads provides the perfect backdrop for a holistic living experience. Schedule a tour today and discover life just steps away from Gahagan Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Gahagan Park SC",
      "seo_description": "Enjoy modern living near Gahagan Park in Summerville at Azure Carnes Crossroads. Stylish apartments with top-notch amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-rosebrock-park-goose-creek-673",
      "search_query": "apartments near Rosebrock Park Goose Creek",
      "category": "Park",
      "h1_title": "Apartments Near Rosebrock Park",
      "h2_subtitle": "Explore apartments near Rosebrock Park in Goose Creek. Azure Carnes Crossroads combines modern living with proximity to natural beauty.",
      "page_copy": "Nestled close to the serene trails of Rosebrock Park in Goose Creek, Azure Carnes Crossroads offers the perfect setting for nature enthusiasts who appreciate modern living. Our community is minutes from Rosebrock Park, providing you with easy access to lush landscapes and outdoor activities.\n\nChoose from spacious one, two, or three-bedroom floor plans, all featuring exceptional amenities like a lagoon-style pool and fitness center. With our corridor-attached garages and select units offering soaking tubs, you’ll have everything you need to unwind after a day exploring the park. Experience exquisite living at Azure Carnes Crossroads, where nature meets contemporary comfort right near Rosebrock Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rosebrock Park SC",
      "seo_description": "Live near Rosebrock Park in Goose Creek at Azure Carnes Crossroads. Discover modern apartment living with comprehensive amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "6767906449167486",
      "source": "custom",
      "page_item_url": "apartments-near-wannamaker-north-trail-sc-38",
      "search_query": "apartments near Wannamaker North Trail SC",
      "category": "Park",
      "h1_title": "Apartments Near Wannamaker North Trail",
      "h2_subtitle": "Find ideal apartments near Wannamaker North Trail. Azure Carnes Crossroads offers a blend of modern amenities and outdoor access in SC.",
      "page_copy": "Situated in beautiful Summerville, SC, Azure Carnes Crossroads provides a perfect blend of proximity to nature and urban sophistication, being just a short distance from Wannamaker North Trail. Ideal for nature lovers, our community offers quick access to miles of scenic trails perfect for biking or hiking adventures.\n\nAzure Carnes Crossroads features one, two, and three-bedroom apartments with luxe amenities, such as our lagoon-style pool and relaxing pavilion lounge. Enjoy the tranquility of Wannamaker North Trail during the day and unwind in our comfortable, modern living spaces by night. Embrace a lifestyle where outdoor adventure meets contemporary home comforts at Azure Carnes Crossroads.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
      "featured_image_media": {
        "alt_text": "Luxurious swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019f6c0b-85f5-7671-8ae7-d197ecde2279",
        "storage_key": "property/6767906449167486/019f6c0b-85f5-7671-8ae7-d197ecde2279.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wannamaker North Trail SC",
      "seo_description": "Live near Wannamaker North Trail in SC. Azure Carnes Crossroads provides modern apartments with unrivaled amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6332"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11926473661"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5669915"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5QMTRM63"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://azurecarne.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54711812167"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "854-888-9011"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlR6NkdlMTRGTm1TN040VkE3N1oyT1E9PSIsInZhbHVlIjoic25yZXVhTkVmVGpUbHhtWWk2ak81QT09IiwibWFjIjoiM2Y4ZGUxYjVhMDkyMTNkYzQxMWUwMGUwYmM3Y2U2YTgyZDU3MmViYTg2ZmJmNTE2OTZjZmJiZDlkODdmYWRlNSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "6332",
  "custom_repli_id": "11926473661",
  "custom_realpage_id": "5669915",
  "custom_google_gtm_id": "GTM-5QMTRM63",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "none",
  "custom_betterbot_script": "<script src=\"https://azurecarne.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "54711812167",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "854-888-9011",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlR6NkdlMTRGTm1TN040VkE3N1oyT1E9PSIsInZhbHVlIjoic25yZXVhTkVmVGpUbHhtWWk2ak81QT09IiwibWFjIjoiM2Y4ZGUxYjVhMDkyMTNkYzQxMWUwMGUwYmM3Y2U2YTgyZDU3MmViYTg2ZmJmNTE2OTZjZmJiZDlkODdmYWRlNSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "9b222ae1-dc87-499a-bb7e-165fd62bed7f",
  "custom_audioeye_site_hash": "57837a9fb14f1af3e4e9bb893849b985"
};

export const generatedAt = '2026-10-19T18:44:48.449Z';
